angular.module('translation', ['pascalprecht.translate'])

    .config(['$translateProvider', function ($translateProvider) {
        $translateProvider.translations('cs_CZ', {
            JAZYK: 'CZ',
            "CZK": "Kč",
            "EUR": "€",
            "USD": "$",
            "COMMON_CLOSE": 'Close',
            "COMMON_ERR_REQUEST": 'Při zpracování Vašeho požadavku se vyskytla chyba.',
            "COMMON_ERR_GEN_DOKLADU_ALL": 'Bohužel se nepodařilo vytvořit archív pro žádný z vybraných dokladů.',
            "COMMON_ERR_GEN_DOKLADU_SELECTED": 'Následující doklady se nepodařilo stáhnout, protože pro ně neexistuje tiskový archiv: ',
            "COMMON_CAPTCHA_TEXT": 'Opište ověřovací kód z obrázku:',
            "SU_ZMENAHESLA_LABEL": 'Změna hesla',
            "SU_ZMENAHESLA_NICKNAME": 'Přihlašovací jméno',
            "SU_ZMENAHESLA_NICKNAME_ERROR": 'Nesprávný formát přihlašovacího jména',
            "SU_ZMENAHESLA_PUK_ERROR": 'Zadejte PUK',
            "SU_ZMENAHESLA_NOVEHESLO": 'Nové heslo',
            "SU_ZMENAHESLA_HESLO_ERROR": 'Neplatný formát hesla.',
            "SU_ZMENAHESLA_HESLO_POZADAVKY": 'Heslo musí obsahovat minimálně 10 znaků, z toho alespoň 1 číslici, 1 velké a 1 malé písmeno. Např. ve tvaru Heslo12345, 123Heslo45.',
            "SU_ZMENAHESLA_POTVRZENIHESLA": 'Potvrzení nového hesla',
            "SU_ZMENAHESLA_HESLANESHODNA": 'Nové heslo není shodné s potvrzením hesla',
            "SU_ZMENAHESLA_ZMENIT": 'Změnit heslo',
            "SU_ZMENAHESLA_EXP_LABEL": 'Změna expirovaného hesla',
            "SU_ZMENAHESLA_STAREHESLO": 'Staré heslo',
            "SU_ZMENAHESLA_STAREHESLO_ERROR": 'Zadejte staré heslo.',
            "SU_ZMENAHESLA_POVINNEUDAJE": 'Údaje označené hvězdičkou jsou povinné.',
            "SU_ZMENAHESLA_LINKZPET": 'Zpět na přihlášení',
            "SU_ZMENAHESLA_ZAPOMENUTE_LABEL": 'Zapomínat je lidské',
            //"SU_ZMENAHESLA_NOTICE": 'Pokud jste zapomněli své přihlašovací jméno nebo registrační e-mail, zavolejte nám na Zákaznickou linku 371 100 100 nebo 800 810 820.',
            "SU_ZMENAHESLA_REG_EMAIL": 'Registrační e-mail',
            "SU_ZMENAHESLA_REG_EMAIL_ERROR": 'Nesprávný formát e-mailové adresy',
            "SU_ZMENAHESLA_OVERIT": 'Ověřit údaje',
            "SU_ZMENAHESLA_ZAKAZNICKECISLO": 'Zákaznické číslo',
            "SU_ZMENAHESLA_ZAKAZNICKECISLO_ERROR": 'Zákaznické číslo je chybné.',
            "SU_ZMENAHESLA_ZAKAZNICKECISLO_ERROR_MIN": 'Zákaznické číslo je příliš krátké.',
            "SU_ZMENAHESLA_ZAKAZNICKECISLO_ERROR_MAX": 'Zákaznické číslo je příliš dlouhé.',
            "SU_ZMENAHESLA_ZAKAZNICKECISLO_INFO": 'Tento údaj najdete na posledním daňovém dokladu (faktuře) za energie od ČEZ a také v e-mailu/SMS, který jsme Vám odeslali.',
            "SU_ZMENAHESLA_DATUMNAROZENI": 'Datum narození',
            "SU_ZMENAHESLA_DATUMNAROZENI_ERROR": 'Datum narození je ve špatném formátu.',
            "SU_ZMENAHESLA_DATUMNAROZENI_INFO": 'Vyplňte datum narození ve formátu DD.MM.RRRR (např. 01.01.1970)',
            "SU_ZMENAHESLA_SHRNUTI_DEKUJEME": 'Děkujeme Vám za použití ESCO Portálu.',
            "SU_ZMENAHESLA_SHRNUTI_HESLOZMENENO": 'Změna hesla proběhla v pořádku, nové heslo můžete ihned použít k přihlášení do ESCO Portálu.',
            "SU_ZMENAHESLA_SHRNUTI_LOGIN": 'Přihlásit se',
            "SU_ZMENAHESLA_SHRNUTI_ODESLANO_1": 'Na adresu ',
            "SU_ZMENAHESLA_SHRNUTI_ODESLANO_2": ' byl zaslán e-mail, pokračujte prosím dle uvedených instrukcí. Platnost tohoto e-mailu je 12 hodin.',
            "SU_REGISTRACE_LABEL": 'Registrace',
            "SU_REGISTRACE_ZAKAZNICKECISLO": 'Zákaznické číslo',
            "SU_REGISTRACE_DOKONCENI_HEADER":'Dokončení registrace',
            "SU_REGISTRACE_ZAKAZNICKECISLO_ERROR_MIN": 'Zákaznické číslo je příliš krátké.',
            "SU_REGISTRACE_ZAKAZNICKECISLO_ERROR_MAX": 'Zákaznické číslo je příliš dlouhé.',
            "SU_REGISTRACE_ZAKAZNICKECISLO_ERROR": 'Zákaznické číslo je chybné.',
            "SU_REGISTRACE_ZAKAZNICKECISLO_INFO": 'Tento údaj najdete na posledním daňovém dokladu (faktuře) za energie od ČEZ a také v e-mailu/SMS, který jsme Vám odeslali.',
           // "SU_REGISTRACE_ZAKAZNICKECISLO_INFO_CUST": 'Tento údaj najdete na smlouvě nebo posledním daňovém dokladu (faktuře) od ČEZ nebo nás kontaktujte na Zákaznické lince 800 810 820, která je Vám k dispozici 24 hodin denně, 7 dní v týdnu.',
            "SU_REGISTRACE_KOMODITA": 'Elektřina, plyn nebo teplo',
            "SU_REGISTRACE_MOBIL": 'Mobil od ČEZ',
            "SU_REGISTRACE_CISLOOM": 'Číslo odběrného místa, EIC nebo EAN',
            "SU_REGISTRACE_CISLOOM_CUST": 'Číslo odběrného místa/EAN',
            "SU_REGISTRACE_CISLOOM_PH": 'Číslo OM/EAN',
            "SU_REGISTRACE_KODMISTA_ERROR": 'Pro identifikaci zákazníka je zapotřebí vyplnit kód místa odběru (číslo odběrného místa, EAN, EIC).',
            "SU_REGISTRACE_KODMISTA_ERROR_PND": 'Pro identifikaci zákazníka je zapotřebí vyplnit místo odběru (číslo odběrného místa nebo EAN).',
            "SU_REGISTRACE_KODMISTA_INFO": 'Tento údaj najdete na posledním daňovém dokladu (faktuře) za energie od ČEZ.',
            //"SU_REGISTRACE_KODMISTA_INFO_CUST": 'Tento údaj najdete na smlouvě nebo posledním daňovém dokladu (faktuře) od ČEZ nebo nás kontaktujte na Zákaznické lince 800 810 820, která je Vám k dispozici 24 hodin denně, 7 dní v týdnu.',
            "SU_REGISTRACE_TELEFONSMS": 'Telefonní číslo',
            "SU_REGISTRACE_TELEFONSMS_ERROR": 'Nesprávný formát telefonního čísla',
            "SU_REGISTRACE_TELEFONSMS_INFO": 'Zadejte telefonní číslo, které je evidované u vaší smlouvy.',
            "SU_REGISTRACE_LOGIN": 'Přihlašovací jméno',
            "SU_REGISTRACE_LOGIN_ERROR": 'Nesprávný formát přihlašovacího jména.',
            "SU_REGISTRACE_LOGIN_ERROR_MAX": 'Uživatelské jméno je příliš dlouhé.',
            "SU_REGISTRACE_LOGIN_ERROR_MIN": 'Uživatelské jméno je příliš krátké.',
            "SU_REGISTRACE_LOGIN_INFO": 'Přihlašovací jméno nesmí obsahovat diakritiku a speciální znaky (tedy pouze znaky A-Z, 0-9). Dále může obsahovat znaky „." a „_". Délka přihlašovacího jména je minimálně 8 znaků.',
            "SU_REGISTRACE_POKRACOVAT": 'Pokračovat',
            "SU_REGISTRACE_GUID_SENT":'Na emailovou adresu byl odeslaný odkaz pro dokončení registrace. Pokračujte prosím podle instrukcí v tomto emailu.',
            "SU_REGISTRACE_GUID_SENT_HEADER":'Email odeslaný',
            "SU_REGISTRACE_IDENTIFIKATOR":'Identifikační údaj',
            "SU_REGISTRACE_IDENTIFIKATOR_HELP":'Vyplňte smluvní telefon, email, zákaznické číslo nebo IČO.',
            "SU_REGISTRACE_DOKONCIT_LABEL": 'Dokončit registraci',
            "SU_REGISTRACE_DOKONCIT_OVERENI": 'Ověření osobních údajů',
            "SU_REGISTRACE_DATUMNAROZENI_ICO": 'Datum narození nebo IČO',
            "SU_REGISTRACE_DATUMNAROZENI_ICO_ERROR": 'Údaj je v nesprávném formátu.',
            "SU_REGISTRACE_DATUMNAROZENI_ICO_INFO": 'IČO nebo datum narození zákazníka ve formátu  DD.MM.RRRR (např. 01.01.1970)',
            "SU_REGISTRACE_DATUMNAROZENI": 'Datum narození',
            "SU_REGISTRACE_DATUMNAROZENI_ERROR": 'Datum narození je ve špatném formátu.',
            "SU_REGISTRACE_DATUMNAROZENI_INFO": 'Datum narození zákazníka ve formátu  DD.MM.RRRR (např. 01.01.1970)',
            "SU_REGISTRACE_ICO": 'IČ',
            "SU_REGISTRACE_ICO_ERROR": 'IČ musí být vyplněné',
            "SU_REGISTRACE_ICO_INFO": 'Z bezpečnostních důvodu prosíme vyplnit IČ firmy',
            "SU_REGISTRACE_TELEFONSMS_OVERENI": 'Telefonní číslo pro ověření',
            "SU_REGISTRACE_TELEFONSMS_ODESLAT": 'Odeslat SMS',
            "SU_REGISTRACE_TELEFONSMS_INFO2": 'Zadejte telefonní číslo, které je uvedené jako kontaktní údaj ve vaší smlouvě s ČEZ.',
            "SU_REGISTRACE_TELEFONSMS_INFO3": 'Po odeslání vám do cca 2 minut pošleme ověřovací kód.',
            "SU_REGISTRACE_KODSMS": 'Ověřovací kód',
            "SU_REGISTRACE_KODSMS_INFO": 'Zadejte ověřovací kód z SMS.',
            "SU_REGISTRACE_KODSMS_ERROR":'Vyplňte ověřovací kód z SMS',
            "SU_REGISTRACE_NASTAVENIUCTU": 'Nastavení účtu v ESCO Portálu',
            "SU_REGISTRACE_NASTAVENIUCTU_PND": 'Nastavení účtu v Portálu naměřených dat',
            "SU_REGISTRACE_JMENO": 'Jméno',
            "SU_REGISTRACE_JMENO_ERROR": 'Jméno je ve špatném tvaru.',
            "SU_REGISTRACE_PRIJMENI": 'Příjmení',
            "SU_REGISTRACE_PRIJMENI_ERROR": 'Příjmení je ve špatném tvaru.',
            "SU_REGISTRACE_EMAIL": 'E-mailová adresa',
            "SU_REGISTRACE_EMAIL_ERROR": 'Nesprávný formát e-mailové adresy',
            "SU_REGISTRACE_HESLO": 'Zvolte si heslo pro přihlašování do ESCO Portálu',
            "SU_REGISTRACE_HESLO_PND": 'Zvolte si heslo pro přihlašování do Portálu naměřených dat',
            "SU_REGISTRACE_HESLO_PH": 'Zadejte heslo',
            "SU_REGISTRACE_HESLO_ERROR": 'Neplatný formát hesla.',
            "SU_REGISTRACE_HESLO_POZADAVKY": 'Heslo musí obsahovat minimálně 10 znaků, z toho alespoň 1 číslici, 1 velké a 1 malé písmeno. Např. ve tvaru Heslo12345, 123Heslo45.',
            "SU_REGISTRACE_HESLO_OVERENI": 'Napište heslo znovu pro ověření',
            "SU_REGISTRACE_HESLO_OVERENI_ERROR": 'Hesla se neshodují',
            "SU_REGISTRACE_SOUHLAS1": 'Souhlasím s ',
            "SU_REGISTRACE_SOUHLAS2": 'podmínkami provozování',
            "SU_REGISTRACE_SOUHLAS_CUST": 'Souhlasím s podmínkami provozování.',
            "SU_REGISTRACE_DOKONCIT": 'Dokončit',
            "SU_REGISTRACE_SHRNUTI_DEKUJEME": 'Děkujeme Vám za použití ESCO Portálu.',
            "SU_REGISTRACE_SHRNUTI_REGISTROVANO": 'Vaše registrace do ESCO Portálu proběhla úspěšně.',
            "SU_REGISTRACE_SHRNUTI_REGISTROVANO_PND": 'Vaše registrace proběhla úspěšně.',
            "SU_REGISTRACE_SHRNUTI_LOGIN": 'Přihlásit se',
            "SO_SAMOOBSLUHA_MAIN_TITLE": 'Samoobsluha',
            "SO_SAMOOBSLUHA_1_TITLE": 'Změna výše záloh',
            "SO_SAMOOBSLUHA_2_TITLE": 'Změna způsobu plateb',
            "SO_SAMOOBSLUHA_3_TITLE": 'Změna adresy',
            "SO_SAMOOBSLUHA_4_TITLE": 'Obecný požadavek',
            "SO_SAMOOBSLUHA_5_TITLE": 'Platební brána',
            "SO_SAMOOBSLUHA_5_PEREX": 'Úhrada zálohy nebo faktury prostřednictvím platební karty',
            "SO_SAMOOBSLUHA_ZMENAVYSEZALOH_TITLE": 'Změna výše záloh',
            "SO_SAMOOBSLUHA_ZMENAZPUSOBUPLATEB_TITLE": 'Změna způsobu plateb',
            "SO_SAMOOBSLUHA_ZMENAVADRESY_TITLE": 'Změna adresy',
            "SO_SAMOOBSLUHA_OBECNYPOZADAVEK_TITLE": 'Obecný požadavek',
            "SO_SAMOOBSLUHA_PLATEBNIBRANA_TITLE": 'Platební brána',
            "SO_SAMOOBSLUHA_ZMENAVYSEZALOH_HELPTEXT1": 'Pro vyplnění budete potřebovat fakturu od stávajícího dodavatele',
            "SO_SAMOOBSLUHA_STEP1_TITLE": 'Identifikace',
            "SO_SAMOOBSLUHA_STEP2_TITLE": 'Váš požadavek',
            "SO_SAMOOBSLUHA_STEP3_TITLE": 'Potvrzení',
            "SO_SAMOOBSLUHA_CUSTOMER_NUMBER1": 'Číslo zákazníka:',
            "SO_SAMOOBSLUHA_CUSTOMER_NUMBER2": 'ČEZ zákaznické číslo',
            "SO_SAMOOBSLUHA_SERVICE_TEXT": 'Vyberte službu které se požadavek týká:',
            "SO_SAMOOBSLUHA_KOMODITA_TEXT": 'Komodita (elektřina, plyn)',
            "SO_SAMOOBSLUHA_EIC_EAN_TEXT": 'Číslo odběrného místa, EIC nebo EAN:',
            "SO_SAMOOBSLUHA_EIC_EAN_INFO": 'Identifikační údaje najdete na vaší poslední faktuře za energie od ČEZ.',
            "SO_SAMOOBSLUHA_TEL_NR_TEXT": 'Telefonní číslo:',
            "SO_SAMOOBSLUHA_TEL_NR_PREFIX": '+420',
            "SO_SAMOOBSLUHA_TEL_NR_INFO": 'Zadejte telefonní číslo, které je evidované u vaší smlouvy.',
            "SO_SAMOOBSLUHA_MOBIL_CEZ_TEXT": 'Mobil od ČEZ',
            "SO_SAMOOBSLUHA_CONTINUE_TEXT": 'Pokračovat',
            "SO_SAMOOBSLUHA_STEP2_TEXT_POZADAVKU": 'Text požadavku:',
            "SO_SAMOOBSLUHA_EMAIL_TEXT": 'Email',
            "SO_SAMOOBSLUHA_EMAIL_INFO": 'Na tento e-mail vám budeme zasílat elektronické faktury.',
            "SO_SAMOOBSLUHA_FILE_TEXT": 'Soubor',
            "SO_SAMOOBSLUHA_SEND_REQUEST_TEXT": 'Odeslat dotaz',
            "SO_SAMOOBSLUHA_STEP3_SEND_TITLE": 'Přejete si odeslat následující požadavek?',
            "SO_SAMOOBSLUHA_STEP3_TEXT1_TITLE": 'Text požadavku',
            "SO_SAMOOBSLUHA_STEP3_TEXT2_TITLE": 'Kontaktní údaje',
            "SO_SAMOOBSLUHA_STEP3_TEXT3_TITLE": 'Přílohy',
            "SO_SAMOOBSLUHA_STEP3_SEND2_TITLE": 'Ověření přes SMS',
            "SO_SAMOOBSLUHA_STEP3_TEXT4_TITLE": 'Poslat autentizační SMS',
            "SO_SAMOOBSLUHA_STEP3_TEXT5_TITLE": 'Autentizační kód',
            "SO_SAMOOBSLUHA_STEP3_TEXT5_TEXT": 'Zadejte autentizační kód z SMS.',
            "SO_SAMOOBSLUHA_STEP3_TEXT5_2_TEXT": 'Ověřovací kód byl odeslán.',
            "SO_SAMOOBSLUHA_STEP3_TEXT6_TITLE": 'E-mailová adresa',
            "SO_SAMOOBSLUHA_STEP3_TEXT6_TEXT": 'Vyplňte email pro zaslání potvrzení',
            "SO_SAMOOBSLUHA_STEP3_BUTTON_TITLE": 'Odeslat požadavek',
            "SO_SAMOOBSLUHA_REQUIRED": 'Musí být zadáno',
            "SO_SAMOOBSLUHA_TEL_NUMBER_FORMAT_ERR": 'Číslo musí být ve formátu XXXXXXXXX.',
            "SO_SAMOOBSLUHA_EMAIL_FORMAT_ERR": 'Nesprávný formát e-mailu.',
            "SO_SAMOOBSLUHA_ZVS_CUSTOMER_TITLE": 'Zákazník:',
            "SO_SAMOOBSLUHA_ZVS_ADDRESS_TITLE": 'Adresa odběrného místa:',
            "SO_SAMOOBSLUHA_ZVS_SVZ_TITLE": 'Stávající výše záloh',
            "SO_SAMOOBSLUHA_ZVS_KC_MONTHS_TITLE": 'Kč měsíčně',
            "SO_SAMOOBSLUHA_ZVS_NVZ_TITLE": 'Nová výše záloh',
            "SO_SAMOOBSLUHA_ZVS_MVZ_TEXT": 'Minimální výše záloh je 490 Kč. Nová výše záloh bude zaokrouhlena v souladu s pravidly zaokrouhlování.',
            "SO_SAMOOBSLUHA_ZVS_MVZ_TEXT_1": 'Minimální výše záloh je ',
            "SO_SAMOOBSLUHA_ZVS_MVZ_TEXT_2": ' Kč. Maximální výše záloh je ',
            "SO_SAMOOBSLUHA_ZVS_MVZ_TEXT_3": ' Kč. Nová výše záloh bude zaokrouhlena v souladu s pravidly zaokrouhlování.',
            "SO_SAMOOBSLUHA_ZVS_NVZ_BUTTON": 'Nastavit výši záloh',
            "SO_SAMOOBSLUHA_ZZP_FAKTURY_TITLE": 'Faktury',
            "SO_SAMOOBSLUHA_ZZP_ZU_TITLE": 'Způsob úhrady',
            "SO_SAMOOBSLUHA_ZZP_BS_TITLE": 'Bankovní spojení',
            "SO_SAMOOBSLUHA_ZZP_ZALOHY_TITLE": 'Zálohy',
            "SO_SAMOOBSLUHA_ZZP_SIPO_TITLE": 'Nové spojovací číslo SIPO',
            "SO_SAMOOBSLUHA_ZZP_PREPLATKY_TITLE": 'Přeplatky',
            "SO_SAMOOBSLUHA_ZZP_ZV_TITLE": 'Způsob vyplacení',
            "SO_SAMOOBSLUHA_ZZP_BUTTON": 'Změnit způsob platby',
            "SO_SAMOOBSLUHA_ZA_NATB_TITLE": 'Nová adresa trvalého bydliště',
            "SO_SAMOOBSLUHA_ZA_ULICE_TITLE": 'Ulice',
            "SO_SAMOOBSLUHA_ZA_CP_TITLE": 'Č.p.',
            "SO_SAMOOBSLUHA_ZA_COR_TITLE": 'Č. or.',
            "SO_SAMOOBSLUHA_ZA_PSC_TITLE": 'PSČ',
            "SO_SAMOOBSLUHA_ZA_OBEC_TITLE": 'Obec',
            "SO_SAMOOBSLUHA_ZA_ADR_IS_SAME_TITLE": 'Doručovací adresa je stejná jako adresa trvalého bydliště.',
            "SO_SAMOOBSLUHA_ZA_BUTTON": 'Potvrdit adresu',
            "SO_SAMOOBSLUHA_PB_STEP1_TITLE": 'Částka k úhradě',
            "SO_SAMOOBSLUHA_PB_STEP2_TITLE": 'Dokončení',
            "SO_SAMOOBSLUHA_PB_NAME": 'Jméno',
            "SO_SAMOOBSLUHA_PB_SURNAME": 'Příjmení',
            "SO_SAMOOBSLUHA_PB_EMAIL": 'Email',
            "SO_SAMOOBSLUHA_PB_EMAIL_INFO": 'Na tento e-mail vám budeme zasílat elektronické faktury.',
            "SO_SAMOOBSLUHA_PB_SUM_TO_PAY": 'Částka k zaplacení:',
            "SO_SAMOOBSLUHA_PB_VS": 'Variabilní symbol:',
            "SO_SAMOOBSLUHA_PB_ZAPLATIT_KARTOU": 'Zaplatit kartou',
            "OM_LABEL": 'Odběrná místa',
            "OM_GENERAL_INFO_1": 'Máte',
            "OM_GENERAL_INFO_2V1": 'odběrné místo',
            "OM_GENERAL_INFO_2V2": 'odběrná místa',
            "OM_GENERAL_INFO_2V3": 'odběrných míst',
            "OM_GENERAL_INFO_3": 'na',
            "OM_GENERAL_INFO_4V1": 'adrese',
            "OM_GENERAL_INFO_4V2": 'adresách',
            "OM_SEARCH": 'Hledat',
            "OM_SEARCH_INFO": 'Napište adresu, EAN nebo číslo odběrného místa.',
            "OM_MENA": 'Kč',
            "OM_OM": 'Odběrné místo',
            "OM_POJM": 'Pojmenovat',
            "OM_PREJM": 'Přejmenovat',
            "OM_POZN": 'Poznámka OM',
            "OM_SAVE": 'Uložit',
            "OM_POZN_ERROR": 'Poznámka odběrného místa obsahuje nepovolené znaky.',
            "OM_STORNO": 'Zrušit',
            "OM_NEBO": 'nebo',
            "OM_INFORMACE": 'Informace',
            "OM_HDO": 'Hromadné dálkové ovládání',
            "OM_SPOTREBICE": 'Nainstalované spotřebiče',
            "OM_PV": 'Plánované vypínání',
            "OM_HO": 'Historie odečítání',
            "OM_ND": 'Naměřená data',
            "OM_VS": 'Vývoj spotřeb',
            "OM_DODAVATEL": 'Dodavatel',
            "OM_DRUHVYROBNY": 'Druh výrobny',
            "OM_OBCHSAZBA": 'Obchodní sazba',
            "OM_DISTRIBUTOR": 'Distributor',
            "OM_DISTSAZBA": 'Distribuční sazba',
            "OM_PRODRADA": 'Produkt',
            "OM_VYSEZALOH": 'Výše záloh',
            "OM_CETNOST": 'Četnost záloh',
            "OM_ROCNISPOTR": 'Předpoklad roční spotřeby',
            "OM_TYPMERENI": 'Typ měření',
            "OM_OSVOBOZENI": 'Osvobození od daně',
            "OM_SKUPINAOM": 'Skupina OM',
            "OM_PARAGRAF": 'paragraf',
            "OM_ANO": 'ANO',
            "OM_TECHUDAJE": 'Technické údaje',
            "OM_CELM": 'Číslo elektroměru',
            "OM_CISLOHDO": 'Číslo HDO',
            "OM_ZPUSOBMERENI": 'Způsob měření',
            "OM_LEGZPUSOBMERENI": 'Legislativní způsob měření',
            "OM_MESREZKAPACITA": 'Měsíční rez. kapacita',
            "OM_ROCREZKAPACITA": 'Roční rez. kapacita',
            "OM_POCETFAZI": 'Počet fází',
            "OM_HLJISTIC": 'Hlavní jistič',
            "OM_REZPRIKON": 'Rezervovaný příkon',
            "OM_NAPHLADINA": 'Napěťová hladina',
            "OM_SPOTMINOBD": 'Spotřeba min. období',
            "OM_TYDENODECTU": 'Týden odečtu',
            "OM_MESICODECTU": 'Měsíc odečtu',
            "OM_UCKONST": 'Účtovací konstanta',
            "OM_REGSTUPEN": 'Regulační stupeň',
            "OM_TARIF": 'Tarif',
            "OM_PLYNOMER": 'Plynoměr',
            "OM_CISLOPLYN": 'Číslo plynoměru',
            "OM_CETNOSTODECTU": 'Četnost odečtu',
            "OM_VYUZITI": 'Využití',
            "OM_CASOVOST": 'Časovost',
            "OM_TYPSAZBY": 'Typ sazby',
            "OM_CISLOMERIDLA": 'Číslo měřidla',
            "OM_ROCSJEDMN": 'Roční sjednané množství',
            "OM_SJEDROCPRIK": 'Sjednaný roční příkon',
            "OM_POCETBYTJEDN": 'Počet bytových jednotek',
            "OM_ROZDOD": 'Rozdělení dodávky',
            "OM_BYTNEBYT": 'byt/nebyt [% byt]',
            "OM_PODLPLOCHA": 'Podlahová plocha',
            "OM_BYTNEBYT2": 'byt/nebyt [m²]',
            "OM_IDVYROBNY": 'ID výrobny',
            "OM_IDZDROJE": 'ID zdroje',
            "OM_DODDOSITE": 'Dodávka do sítě',
            "OM_DRUHPODP": 'Druh podpory',
            "OM_ODECTJEDN": 'Odečtová jednotka',
            "OM_FAKUDAJE": 'Fakturační údaje',
            "OM_ZPUHRADY": 'Způsob úhrady',
            "OM_ZPUVRAC": 'Způsob vracení',
            "OM_CU": 'Číslo účtu',
            "OM_IBAN": 'IBAN',
            "OM_SIPO": 'Spojovací číslo SIPO',
            "OM_KONTUDAJ": 'Kontaktní údaje',
            "OM_ADRESA": 'Adresa trvalého bydliště',
            "OM_ZASADRESA": 'Zasílací adresa',
            "OM_ZMENITUDAJE": 'Změnit údaje',
            "OM_ZMENIT": 'Změnit',
            "OM_SLUZBY": 'Nabízené služby',
            "OM_ELFA": 'Elektronická fakturace',
            "OM_ELFA_KONTAKT": 'Kontakt pro notifikaci',
            "OM_AKTIVNI": 'Aktivní',
            "OM_NEAKTIVNI": 'Neaktivní',
            "OM_AKTIVOVAT": 'Aktivovat',
            "OM_DATSOUBOR": 'Datový soubor',
            "OM_POJIST": 'ČEZ Bez starostí',
            "OM_PND": 'Portál naměřených dat',
            "OM_ASISTENT": 'ČEZ ASISTENT',
            "OM_MESFAK": 'Měsíční faktura',
            "OM_FAK24": 'Faktura 24',
            "OM_EFAK": 'e-faktura',
            "OM_OZNODST": 'Oznamování odstávek',
            "OM_SMLOBCH": 'Smlouva / Obchodní zástupce',
            "OM_VYSTAVIT": 'Vystavit',
            "OM_OZ": 'Obchodní zástupce',
            "OM_JMENO": 'Jméno',
            "OM_TEL": 'Telefon',
            "OM_MOB": 'Mobil',
            "OM_EMAIL": 'E-mail',
            "OM_VS_DATEPICK": 'Zobrazit data pro období',
            "OM_OD": 'Od',
            "OM_DO": 'Do',
            "OM_DATUMODDO": 'Datum od - do',
            "OM_SPVT": 'Spotřeba VT [kWh]',
            "OM_SPNT": 'Spotřeba NT [kWh]',
            "OM_SP": 'Spotřeba [kWh]',
            "OM_AVGSPVT": 'Průměrná spotřeba VT [kWh/den]',
            "OM_AVGSPNT": 'Průměrná spotřeba NT [kWh/den]',
            "OM_AVGSP": 'Průměrná spotřeba [kWh/den]',
            "OM_SAZBAOBCH": 'Sazba obchod',
            "OM_SAZBADIST": 'Sazba distribuce',
            "OM_CENA": 'Cena',
            "OM_SPOTREBIC": 'Spotřebič',
            "OM_EVIDKW": 'Evidované kW',
            "OM_NOVEKW": 'Nové kW',
            "OM_KODHDO": 'Kód HDO',
            "OM_CHARODB": 'Charakter odběru',
            "OM_INSTPRIK": 'Nainstalovaný příkon',
            "OM_RIZPRIK": 'Řízený příkon',
            "OM_SIGNAL": 'Signál',
            "OM_ZOBRKDATU": 'Zobrazit k datu',
            "OM_DEN": 'Den',
            "OM_DATUM": 'Datum',
            "OM_CASY": 'Časy',
            "OM_VT": 'VT (kWh)',
            "OM_NT": 'NT (kWh)',
            "OM_POPIS": 'Popis',
            "OM_STAVM3": 'Stav (m3)',
            "OM_STAV": 'Stav',
            "OM_ZADNEVYPINANI": 'K odběrnému místu neevidujeme k dnešnímu dni žádné plánované vypínání elektřiny.',
            "OM_TERMIN": 'Termín',
            "OM_DUVOD": 'Důvod',
            "OM_KOMODITA_ELE": 'Elektřina',
            "OM_KOMODITA_PLYN": 'Plyn',
            "OM_KOMODITA_TEPLO": 'Teplo',
            "OM_KOMODITA_MOB": 'Mobil od ČEZ',
            "OM_KOMODITA_JINE": 'Jiné',
            "OM_KOMODITA_VYROBNA": 'Elektřina',
            "OM_UNK": 'Nerozpoznáno',
            "OM_ZAL_NE": 'Nejsou zálohy',
            "OM_ZAL_MES": 'Měsíční zálohy',
            "OM_ZAL_DVMES": 'Dvouměsíční zálohy',
            "OM_ZAL_CTVRTLET": 'Čtvrtletní zálohy',
            "OM_ZAL_CTYRMES": 'Čtyřměsíční zálohy',
            "OM_ZAL_PULR": 'Půlroční zálohy',
            "OM_ZAL_ROCNI": 'Roční zálohy',
            "OM_ZPMER_PRIME": 'Přímé měření',
            "OM_ZPMER_POLOPRIME": 'Polopřímé měření',
            "OM_ZPMER_NEPRIME": 'Nepřímé měření',
            "OM_ZPMER_NEPRPRIMECAST": 'Nepř./část. nepř. měření',
            "OM_MES1": 'Leden',
            "OM_MES2": 'Únor',
            "OM_MES3": 'Březen',
            "OM_MES4": 'Duben',
            "OM_MES5": 'Květen',
            "OM_MES6": 'Červen',
            "OM_MES7": 'Červenec',
            "OM_MES8": 'Srpen',
            "OM_MES9": 'Září',
            "OM_MES10": 'Říjen',
            "OM_MES11": 'Listopad',
            "OM_MES12": 'Prosinec',
            "OM_NEURCENO": 'Neurčeno',
            "OM_OMELE1": 'odběrné místo elektřiny',
            "OM_OMELE2": 'odběrná místa elektřiny',
            "OM_OMELE3": 'odběrných míst elektřiny',
            "OM_OMPLYN1": 'odběrné místo plynu',
            "OM_OMPLYN2": 'odběrná místa plynu',
            "OM_OMPLYN3": 'odběrných míst plynu',
            "OM_OMTEP1": 'odběrné místo tepla',
            "OM_OMTEP2": 'odběrná místa tepla',
            "OM_OMTEP3": 'odběrných míst tepla',
            "OM_OMVYR1": 'výrobna elektřiny',
            "OM_OMVYR2": 'výrobny elektřiny',
            "OM_OMVYR3": 'výroben elektřiny',
            "OM_OMPOZE": 'POZE',
            "OM_ZADNAOM": 'Pro dané zákaznické číslo nejsou evidována žádná odběrná místa.',
            "OM_ZADNAOM_PF": 'Pro dané zákaznické číslo nejsou evidována žádná odběrná místa, kterým lze provést predikci faktury.',
            "OM_SMLVYST": 'Stav smlouvy: Vystavuje se',
            "OM_NASTAVIT": 'Nastavit',
            "OM_ELEOZNNN": 'Zasílání zpráv o plánovaných odstávkách',
            "OM_SML_PRODEJ": 'Smlouva s ',
            "OM_SML_DIST": 'Smlouva s ',
            "OM_SML_PRODEJ_SHORT": '(ČEZ Prodej, a.s.)',
            "OM_SML_DIST_SHORT": '(ČEZ Distribuce, a.s.)',
            "OM_ADV_SEARCH": 'Rozšířené hledání',
            "OM_NOTITLE": 'Poznámka OM nebyla vyplněna.',
            "OM_ZALOHY": 'Zálohy',
            "OM_PREPLATKY": 'Přeplatky',
            "OM_ZAEVIDOVAN": 'Požadavek byl zaevidován',
            "OM_ODST_INFO": 'Zobrazené informace o plánované odstávce elektřiny mají pouze informativní charakter. Plánovaný začátek a konec omezení nebo přerušení dodávky elektřiny je provozovatelem distribuční soustavy oznamováno v souladu s § 25 odst. 6 zák. č. 458/2000 Sb.(energetický zákon) způsobem v místě obvyklým.',
            "OM_ZADNAOM_PREDIKCE": 'Nebylo nalezeno žádné odběrné místo, pro které lze provést predikci faktury.',
            "FA_LABEL": 'Faktury a zálohy',
            "FA_VSECHNAOM": 'Pro všechna odběrná místa.',
            "FA_VSECHNAOP": 'Pro všechny obchodní partnery.',
            "FA_ZVOLOM": 'Pouze pro zvolená odběrná místa.',
            "FA_VYBRATOM": 'Vybrat odběrná místa',
            "FA_AKTUALIZOVANO": 'Zobrazená data byla aktualizována',
            "FA_UPDATE": 'aktualizovat',
            "FA_FILTR": 'Filtr',
            "FA_VLASTNI": 'Vlastní',
            "FA_ADVSEARCH": 'Podrobné hledání',
            "FA_STORNO": 'Zrušit',
            "FA_NORESULTS": 'Nebyly nalezeny žádné výsledky.',
            "FA_SEARCH": 'Hledat',
            "FA_SEARCH_INFO": 'Napište částku, nebo variabilní symbol.',
            "FA_DOKLAD": 'Doklad',
            "FA_DOPLATIT": 'Částka k doplacení',
            "FA_STAV": 'Stav',
            "FA_ZDANPLNENI": 'Zdanitelné plnění',
            "FA_VARSYMBOL": 'Variabilní symbol',
            "FA_VARSYMBOL_DESC": 'Variabilní symbol sestupně',
            "FA_VARSYMBOL_PH": 'Var. symbol',
            "FA_SPLATNOST": 'Splatnost',
            "FA_PRIDATDOKOSIKU": 'Přidat k úhradě',
            "FA_PLATBANACESTE": 'Platba na cestě',
            "FA_VKOSIKU": 'Přidáno',
            "FA_SORTBY": '-- Řadit podle --',
            "FA_DATVYST": 'Data vystavení',
            "FA_DATVYST_DESC": 'Data vystavení sestupně',
            "FA_DATSPLAT": 'Data splatnosti',
            "FA_DATSPLAT_DESC": 'Data splatnosti sestupně',
            "FA_MAXTOP": 'Částky',
            "FA_MINTOP": 'Částky sestupně',
            "FA_SELECT": 'Vybrat',
            "FA_SELECT_LABEL": '-- Vybrat --',
            "FA_ALL": 'Vše',
            "FA_NONE": 'Nic',
            "FA_REVERSE": 'Opačně',
            "FA_POHL": 'Pohledávky',
            "FA_NEUHRAZENE": 'Neuhrazené',
            "FA_AKCE": '-- Akce --',
            "FA_DLPDF": 'Stáhnout jako PDF',
            "FA_DLISDOC": 'Stáhnout jako ISDOC',
            "FA_DLCSV": 'Stáhnout jako CSV',
            "FA_SLREAD": 'Označit jako prohlédnuté',
            "FA_SLUNREAD": 'Označit jako neprohlédnuté',
            "FA_SELECTOM": 'Vyberte odběrné místo',
            "FA_SEARCHOM_INFO": 'Napište adresu, EAN nebo číslo odběrného místa.',
            "FA_ADVSEARCH_LABEL": 'Podrobné hledání dokladů',
            "FA_KOMODITA_ELE": 'Elektřina',
            "FA_KOMODITA_PLYN": 'Plyn',
            "FA_KOMODITA_TEPLO": 'Teplo',
            "FA_LKOMODITA_MOBIL": 'Mobil od ČEZ',
            "FA_KOMODITA_JINE": 'Jiné',
            "FA_KOMODITA_VYROBNA": 'Elektřina',
            "FA_ZALOHY": 'Zálohy',
            "FA_FAKTURY": 'Faktury',
            "FA_PRIJPLATBY": 'Přijaté platby',
            "FA_UPOMINKY": 'Upomínky',
            "FA_DALSIDOKL": 'Další doklady',
            "FA_SMLPOKUTY": 'Smluvní pokuty',
            "FA_POPLATKY": 'Poplatky',
            "FA_KAUCE": 'Kauce',
            "FA_NEZZAL": 'Nezaúčtované zálohy',
            "FA_SELFBIL": 'Self-billing',
            "FA_UROKY": 'Úroky',
            "FA_ZNOVUPRIP": 'Znovupřipojení',
            "FA_ZASTPRIP": 'Zastavení přerušení',
            "FA_STORNA": 'Storna',
            "FA_OST": 'Ostatní',
            "FA_SPLATVOBD": 'Splatnost v období',
            "FA_ZMENIT": 'Změnit',
            "FA_OD": 'Od',
            "FA_DO": 'Do',
            "FA_BLIZISESPLAT": 'Blíží se splatnost',
            "FA_MINMESIC": 'Minulý měsíc',
            "FA_CELYROK": 'Celý rok',
            "FA_LONSKYROK": 'Loňský rok',
            "FA_BEZOMEZENÍ": 'Bez omezení',
            "FA_VYSTVOBD": 'Vystaveno v období',
            "FA_POSLTYDEN": 'Poslední týden',
            "FA_CASTKA": 'Částka',
            "FA_INPROZSAH": 'Zadat rozsah',
            "FA_STRCASTKA": 'Přesná částka',
            "FA_ZBYVADOPL": 'Zbývá doplatit',
            "FA_DOPLOD": 'Doplatit od',
            "FA_CISLOMERIDLA": 'Číslo měřidla',
            "FA_CISLOMERIDLA_PH": 'Č. měřidla',
            "FA_POUZENEZAPL": 'Pouze nezaplacené',
            "FA_SHOWRESULTS": 'Zobrazit výsledky',
            "FA_DOKLKZAPL": 'Doklady k zaplacení',
            "FA_CARTEMPTY": 'Košík je prázdný',
            "FA_TOTAL": 'Celková částka k úhradě',
            "FA_PAYMETHOD": 'Vyberte platební metodu',
            "FA_PAY": 'Přejít na platební bránu',
            "FA_VYSTAVENI": 'Vystavení',
            "FA_CISLODD": 'Číslo daň. dokladu',
            "FA_DETAILPLATEB": 'Detail plateb',
            "FA_MENA": 'Měna',
            "FA_UHRAZENO": 'Uhrazeno',
            "FA_DALSIINFO": 'Další informace',
            "FA_DODINFO": 'Dodatečné informace',
            "FA_NOTIFIKACE": 'Notifikace',
            "FA_TYP": 'Typ',
            "FA_DATUM": 'Datum',
            "FA_PRIJEMCE": 'Příjemce',
            "FA_HISTUPO": 'Historie upomínání',
            "FA_TYPUPO": 'Typ upomínky',
            "FA_VYSTAVENO": 'Vystaveno',
            "FA_VYTVORENO": 'Vytvořeno',
            "FA_PLATBA": 'Platba',
            "FA_ZBYVAUHR": 'Zbývá uhradit',
            "FA_DL": 'Stáhnout',
            "FA_SOUVDOK": 'Související doklady',
            "FA_DRUHDOK": 'Druh dokladu',
            "FA_DATZAZ": 'Datum záznamu',
            "FA_CISLOKONT": 'Číslo kontaktu',
            "FA_FAKTUROVANO": 'Fakturováno',
            "FA_KESTAZENI": 'Ke stažení',
            "FA_SOUHFAK": 'Souhrnná faktura',
            "FA_POKUTAZAHR": 'Pokuta zahrnutá v upomínce',
            "FA_PLATBADOK": 'Platba dokladu',
            "FA_NADDOK": 'Nadřazený doklad',
            "FA_VICE": 'Zobrazit více',
            "FA_BANKA": 'Hradit ve prospěch účtu',
            "FA_CISLOU": 'Číslo účtu',
            "FA_IBAN": 'IBAN',
            "FA_UCET": 'účet',
            "FA_OM": 'Odběrná místa',
            "FA_CISLOOM": 'Číslo OM',
            "FA_ADRESA": 'Adresa',
            "FA_POZN": 'Poznámka',
            "FA_UPDATE_WARN": 'Aktualizací stránky dojde ke smazání položek v košíku, opravdu chcete pokračovat?',
            "FA_STATUS_UHRAZENO": 'Uhrazeno',
            "FA_STATUS_PREDSPL": 'Před splatností',
            "FA_STATUS_NEUHRAZENO": 'Neuhrazeno',
            "FA_STATUS_PRIJPLT": 'Přijatá platba',
            "FA_STATUS_KVYPL": 'K výplatě',
            "FA_STATUS_VYPLACENO": 'Vyplaceno',
            "FA_STATUS_NEPLAT": 'Neplaťte',
            "FA_STATUS_PREVEDENO": 'Převedeno',
            "FA_STATUS_VYFAK": 'Vyfakturováno',
            "FA_STATUS_NENIPOZ": 'Není požadováno',
            "FA_STATUS_NEVYPL": 'Nevyplaceno',
            "FA_STATUS_VSOUHF": 'Zahrnuto v souhrnné faktuře',
            "FA_STATUS_VSOUHZ": 'Zahrnuto v souhrnné záloze',
            "FA_STATUS_PAYU": 'Uhrazeno',
            "FA_STATUS_INKASOVANO": 'Inkasováno',
            "FA_STATUS_VLADNI_PODPORA": 'Vládní podpora',
            "FA_TYPDOKLADU_ALL": 'Celkový přehled',
            "FA_TYPDOKLADU_BBP": 'Záloha',
            "FA_TYPDOKLADU_INV": 'Faktura',
            "FA_TYPDOKLADU_PLB": 'Platba',
            "FA_TYPDOKLADU_UPO": 'Upomínka',
            "FA_TYPDOKLADU_POK": 'Smluvní pokuta',
            "FA_TYPDOKLADU_POZ": 'Poplatek',
            "FA_TYPDOKLADU_KAU": 'Kauce',
            "FA_TYPDOKLADU_BBO": 'Nezaúčtovaná záloha',
            "FA_TYPDOKLADU_SLF": 'Self-billing',
            "FA_TYPDOKLADU_URO": 'Úrok',
            "FA_TYPDOKLADU_PRI": 'Znovupřipojení',
            "FA_TYPDOKLADU_PRE": 'Zastavení přerušení',
            "FA_TYPDOKLADU_STN": 'Storno',
            "FA_TYPDOKLADU_OST": 'Ostatní',
            "FA_TYPDOKLADU_UNK": 'Neznámá položka',
            "FA_DATE_DEN1": ' den',
            "FA_DATE_DEN2": ' dny',
            "FA_DATE_DEN3": ' dní',
            "FA_DATE_SPLZA": 'Splatnost za ',
            "FA_DATE_POSPL": ' po splatnosti.',
            "FA_DATE_SPLDNES": 'Splatnost dnes',
            "FA_DATE_CHYBA": 'Chyba: ',
            "FA_TYPNOTIF_SMS": 'SMS',
            "FA_TYPNOTIF_EMAIL": 'E-mail',
            "FA_TYPNOTIF_DOPIS": 'Dopis',
            "FA_TYPNOTIF_UNK": 'Neznámé',
            "FA_PDF_PROGRESS": 'PDF doklad faktury pro Vás právě připravujeme, k dispozici bude nejpozději do 2 pracovních dnů od data vystavení faktury.',
            "FA_DAN_DOKLAD": 'Daňový doklad',
            "FA_DAN_DOKLAD_STAHNOUT": 'Stáhnout',
            "DA_LABEL": 'Přehled účtu',
            "DA_FA": 'Faktury',
            "DA_SEARCH": 'Hledat',
            "DA_SEARCH_INFO": 'Napište částku, nebo variabilní symbol.',
            "DA_ADVSEARCH": 'Podrobné hledání',
            "DA_OM": 'Odběrná místa',
            "DA_OMSEARCH_INFO": 'Napište adresu, EAN nebo číslo odběrného místa.',
            "DA_MOB": 'Mobil od ČEZ',
            "DA_CISLOOM": 'Číslo odběrného místa',
            "DA_DATUM_OD": 'Datum od',
            "DA_DATUM_DO": 'Datum do',
            "DA_ADRESA": 'Adresa',
            "DA_DUVOD": 'Důvod',
            "DA_ODSTAVKY": 'Odstávky',
            "DA_PREJDETE": 'Přejděte k ČEZ',
            "DA_PRODOMACNOST": 'pro domácnost',
            "DA_PROFIRMY": 'pro firmy',
            "DA_UDAJESPRAVNE": 'Jsou tyto údaje správné?',
            "DA_ZKONTRUD": 'Zkontrolujte si prosím své kontaktní údaje. Předejdete tím případným nedorozuměním. Pokud na Váš účet přistupuje více uživatelů, je možné provést jejich sloučení.',
            "DA_ZAKCIS": 'Zákaznické číslo',
            "DA_ADRESATB": 'Adresa trvalého bydliště',
            "DA_ADRESASF": 'Adresa sídla firmy',
            "DA_ZMENITUD": 'Změnit údaje',
            "DA_TELEFON": 'Telefon',
            "DA_MOBIL": 'Mobil',
            "DA_EMAIL": 'E-mailová adresa',
            "DA_DATA_BOX": 'Datová schránka',
            "DA_OK": 'OK, údaje jsou v pořádku',
            "DA_ZADNE_ODSTAVKY": 'Nejsou evidovány žádné odstávky.',
            "DA_ADVSEARCHOM": 'Podrobné hledání odběrných míst',
            "DA_ULICE": 'Ulice',
            "DA_CP": 'Č.popisné',
            "DA_MESTO": 'Město',
            "DA_PSC": 'PSČ',
            "DA_KOMODITA": 'Komodita',
            "DA_EANEIC": 'EAN / EIC',
            "DA_ZOBRVYSL": 'Zobrazit výsledky',
            "DA_NEDOSTUPNOST": 'Vážení zákazníci, dovolujeme si vás upozornit na plánovanou nedostupnost ESCO Portálu.',
            "PF_NADPIS_GRAF": 'Předpokládaný průběh spotřeby elektřiny dle TDD',
            "PF_NADPIS_GRAF_PLYN": 'Předpokládaný průběh spotřeby plynu dle TDD',
            "PF_STAV": 'Stav elektroměru k dnešnímu datu',
            "PF_STAV_PLYN": 'Stav plynoměru k dnešnímu datu',
            "PF_CETNOST_1": 'Vaše aktuální výše měsíčních záloh:',
            "PF_CETNOST_3": 'Vaše aktuální výše čtvrtletních záloh:',
            "PF_CETNOST_N": 'Vaše aktuální výše záloh:',
            "MRK_MAIN_TITLE": 'Rezervované kapacity OM z hladiny VN a VVN',
            "MRK_PRO_ODB_MISTO": 'Pro odběrné místo',
            "MRK_CHANGE": 'Změnit',
            "MRK_INFO_TEXT_1": 'Snížení roční rezervované kapacity je možné provádět po uplynutí 12 měsíců od poslední změny a vždy čeká na schválení příslušným distributorem.',
            "MRK_YEAR": 'Rok',
            "MRK_REZ_PRIKON": 'Rezervovaný příkon',
            "MRK_KWH": 'kWh',
            "MRK_KW": 'kW',
            "MRK_SUM": 'Součet roční a měsíční RK',
            "MRK_ROCNI_REZ_KAP": 'Roční rez. kap.',
            "MRK_EVIDOVANA_HOD": 'Měsíční evidovaná rez. kap.',
            "MRK_SJEDNANA_HOD": 'Měsíční požadovaná rez. kap.',
            "MRK_MES1": 'Leden',
            "MRK_MES2": 'Únor',
            "MRK_MES3": 'Březen',
            "MRK_MES4": 'Duben',
            "MRK_MES5": 'Květen',
            "MRK_MES6": 'Červen',
            "MRK_MES7": 'Červenec',
            "MRK_MES8": 'Srpen',
            "MRK_MES9": 'Září',
            "MRK_MES10": 'Říjen',
            "MRK_MES11": 'Listopad',
            "MRK_MES12": 'Prosinec',
            "MRK_SAVE_CHANGES": 'Uložit změny',
            "MRK_OR": 'nebo',
            "MRK_BACK": 'zpět',
            "SD_SOHEDM_TITLE": 'Sjednání odběrových hodnot EDM',
            "SD_PRO_ODB_MISTO": 'Pro odběrné místo:',
            "SD_CHANGE": 'Změnit',
            "SD_CHOOSE_PROFIL": 'Vyberte profil a výpis',
            "SD_PROFIL": 'Profil',
            "SD_PROFIL_1": 'Denní',
            "SD_PROFIL_2": 'Týdenní',
            "SD_PROFIL_3": 'Skutečné hodnoty',
            "SD_PROFIL_4": 'Všechny profily',
            "SD_FROM_DATE": 'Od data',
            "SD_FROM_1": 'Automaticky',
            "SD_FROM_2": 'Zvolit datum',
            "SD_BUTTON_SHOW_PROFIL": 'Zobrazit vybraný profil',
            "SD_BUTTON_EXPORT_XLS": 'Export hodnot do MS Excel',
            "SD_OR": 'nebo',
            "SD_BACK": 'Zpět',
            "SD_MONTH": 'měsíc',
            "SD_WEEK": 'týden',
            "SD_DAY": 'den',
            "SD_SET_DISPLAY": 'Nastavit zobrazení',
            "SD_SAVE_DATA": 'Uložit zadaná data',
            "SD_JEDNOTKY": 'Jednotky sjednávání jsou',
            "SD_SET": 'Nastavit',
            "SD_SJEDNANI_SETTING_TITLE": 'Sjednání odběrových hodnot EDM - nastavení',
            "SD_TABLE": 'Tabulka',
            "SD_DAY_NRS": 'Počet dní',
            "SD_GENERAL": 'Obecné',
            "SD_REFRESH": 'Refresh',
            "SD_CONTACT_PERSON": 'Kontaktní osoba',
            "SD_JEDNOTKY2": 'Jednotky pro elektřinu',
            "SF_TITLE": 'Simulace faktury',
            "SF_PRO_ODB_MISTO": 'Pro odběrné místo:',
            "SF_CHANGE": 'Změnit',
            "SF_NAPOVEDA": 'Nápověda',
            "SF_NAPOVEDA_TEXT": 'Faktura bude simulována ke zvolenému dni. Ten musí být zadán v rozmezí od data poslední fakturace do dnešního dne.',
            "SD_SPOTREBA_TITLE": 'Zadejte spotřebu přístroje',
            "SD_DATUM_SAMOODECTU": 'Datum samoodečtu',
            "SD_POSLEDNI_FAK_STAV_VT": 'Poslední fakturovaný stav VT',
            "SD_SAMOODECET_VYS_TARIFU": 'Samoodečet vysokého tarifu',
            "SD_KWH": 'kWh',
            "SD_POSLEDNI_FAK_STAV_NT": 'Poslední fakturovaný stav NT',
            "SD_SAMOODECET_NIZ_TARIFU": 'Samoodečet nízkého tarifu',
            "SD_SAMOODECET": 'Samoodečet',
            "SD_POSLEDNI_FAK_STAV": 'Poslední fakturovaný stav',
            "SD_VYGENEROVAT_FAKTURU": 'Vygenerovat fakturu',
            "SF_ALERT_WARNING": 'Výpočet je pouze orientační, simulace vyúčtovací faktury nenahrazuje řádnou vyúčtovací fakturu.',
            "SF_SIMUL_TO_DATE": 'Simulovaná faktura ke dni',
            "SF_MACHINE_NR": 'Číslo přístroje',
            "SF_SPOTREBA_ZA_OBD": 'Spotřeba za období',
            "SF_SPOTREBA_ZA_OBD_VT": 'Spotřeba za období VT',
            "SF_SPOTREBA_ZA_OBD_VNT": 'Spotřeba za období VT + NT',
            "SF_PREDPOKLAD_CENA": 'Předpokládaná cena',
            "SF_PRIJATE_PLATBY": 'Přijaté platby',
            "SF_ROZDIL": 'Rozdíl',
            "SF_PREPLATEK": 'Přeplatek',
            "SF_PRINT_INVOICE": 'Vytisknout fakturu',
            "SF_INCLUDING_VAT": 'Veškeré položky jsou uvedeny včetně DPH.',
            "SF_DOPLATEK": 'Doplatek'
        });
        $translateProvider.translations('sk_SK', {
            JAZYK: 'SK',
            "CZK": "CZK",
            "EUR": "€",
            "USD": "$",
            "COMMON_CLOSE": 'Close',
            "COMMON_ERR_REQUEST": 'Pri spracovaní vašej požiadavky sa vyskytla chyba.',
            "COMMON_ERR_GEN_DOKLADU_ALL": 'Bohužiaľ sa nepodarilo vytvoriť archív pre žiadny z vybraných dokladov.',
            "COMMON_ERR_GEN_DOKLADU_SELECTED": 'Nasledovné doklady sa nepodarilo stiahnuť, pretože pre ne neexistuje tlačový archív: ',
            "COMMON_CAPTCHA_TEXT": 'Opište ověřovací kód z obrázku:',
            "SU_ZMENAHESLA_LABEL": 'Zmena hesla',
            "SU_ZMENAHESLA_NICKNAME": 'Prihlasovacie meno',
            "SU_ZMENAHESLA_NICKNAME_ERROR": 'Nesprávny formát prihlasovacieho mena',
            "SU_ZMENAHESLA_PUK_ERROR": 'Zadajte PUK',
            "SU_ZMENAHESLA_NOVEHESLO": 'Nové heslo',
            "SU_ZMENAHESLA_HESLO_ERROR": 'Neplatný formát hesla.',
            "SU_ZMENAHESLA_HESLO_POZADAVKY": 'Heslo musí obsahovať minimálne 10 znakov, z toho aspoň 1 číslicu, 1 veľké a 1 malé písmeno. Napr. v tvare Heslo12345, 123Heslo45.',
            "SU_ZMENAHESLA_POTVRZENIHESLA": 'Potvrdenie nového hesla',
            "SU_ZMENAHESLA_HESLANESHODNA": 'Nové heslo nie je zhodné s potvrdením hesla',
            "SU_ZMENAHESLA_ZMENIT": 'Zmeniť heslo',
            "SU_ZMENAHESLA_EXP_LABEL": 'Zmena expirovaného hesla',
            "SU_ZMENAHESLA_STAREHESLO": 'Staré heslo',
            "SU_ZMENAHESLA_STAREHESLO_ERROR": 'Zadajte staré heslo.',
            "SU_ZMENAHESLA_POVINNEUDAJE": 'Údaje označené hviezdičkou sú povinné.',
            "SU_ZMENAHESLA_LINKZPET": 'Späť na prihlásenie',
            "SU_ZMENAHESLA_ZAPOMENUTE_LABEL": 'Zabúdať je ľudské',
            "SU_ZMENAHESLA_REG_EMAIL": 'Registračný e-mail',
            "SU_ZMENAHESLA_REG_EMAIL_ERROR": 'Nesprávny formát e-mailovej adresy',
            "SU_ZMENAHESLA_OVERIT": 'Overiť údaje',
            "SU_ZMENAHESLA_ZAKAZNICKECISLO": 'Zákaznícke číslo',
            "SU_ZMENAHESLA_ZAKAZNICKECISLO_ERROR": 'Zákaznícke číslo je nesprávne.',
            "SU_ZMENAHESLA_ZAKAZNICKECISLO_ERROR_MAX": 'Zákaznícke číslo je príliš dlhé.',
            "SU_ZMENAHESLA_ZAKAZNICKECISLO_INFO": 'Tento údaj nájdete na poslednom daňovom doklade (faktúre) za energie od ČEZ a tiež v e-maile/SMS, ktorý sme Vám odoslali.',
            "SU_ZMENAHESLA_DATUMNAROZENI": 'Dátum narodenia',
            "SU_ZMENAHESLA_DATUMNAROZENI_ERROR": 'Dátum narodenia je v nesprávnom formáte.',
            "SU_ZMENAHESLA_DATUMNAROZENI_INFO": 'Vyplňte dátum narodenia vo formáte DD.MM.RRRR (napr. 01.01.1970)',
            "SU_ZMENAHESLA_SHRNUTI_DEKUJEME": 'Ďakujeme Vám za použitie ESCO Portálu.',
            "SU_ZMENAHESLA_SHRNUTI_HESLOZMENENO": 'Zmena hesla prebehla v poriadku, nové heslo môžete ihneď použiť k prihláseniu do ESCO Portálu.',
            "SU_ZMENAHESLA_SHRNUTI_LOGIN": 'Prihlásiť sa',
            "SU_ZMENAHESLA_SHRNUTI_ODESLANO_1": 'Na adresu[',
            "SU_ZMENAHESLA_SHRNUTI_ODESLANO_2": '] bol odoslaný e-mail, pokračujte prosím podľa uvedených inštrukcií. Platnosť tohoto e-mailu je 12 hodín.',
            "SU_REGISTRACE_LABEL": 'Registrácia',
            "SU_REGISTRACE_DOKONCENI_HEADER":'Dokončenie registrácie',
            "SU_REGISTRACE_GUID_SENT":'Na emailovú adresu bol odoslaný odkaz pre dokončenie registrácie. Pokračujte prosím podľa inštrukcií v tomto maile.',
            "SU_REGISTRACE_GUID_SENT_HEADER":'Email odoslaný',
            "SU_REGISTRACE_IDENTIFIKATOR_HELP":'Vyplňte zmluvné telefón, email, zákaznícke číslo alebo IČO.',
            "SU_REGISTRACE_IDENTIFIKATOR":'Identifikačný údaj',
            "SU_REGISTRACE_ZAKAZNICKECISLO": 'Zákaznícke číslo',
            "SU_REGISTRACE_ZAKAZNICKECISLO_ERROR_MAX": 'Zákaznícke číslo je príliš dlhé.',
            "SU_REGISTRACE_ZAKAZNICKECISLO_ERROR": 'Zákaznícke číslo je nesprávne.',
            "SU_REGISTRACE_ZAKAZNICKECISLO_INFO": 'Tento údaj nájdete na poslednom daňovom doklade (faktúre) za energie od ČEZ a tiež v e-maile/SMS, ktorý sme Vám odoslali.',
            "SU_REGISTRACE_ZAKAZNICKECISLO_INFO_CUST": 'Tento údaj nájdete na zmluve, alebo poslednom daňovom doklade (faktúre) od ČEZ alebo nás kontaktujte na Zákazníckej linke 0850 888 444, ktorá je Vám k dispozícii v pracovných dňoch od 8:00 do 18:00.',
            "SU_REGISTRACE_KOMODITA": 'Elektrina, plyn alebo teplo',
            "SU_REGISTRACE_MOBIL": 'Mobil od ČEZ',
            "SU_REGISTRACE_CISLOOM": 'Číslo odberného miesta, EIC alebo POD',
            "SU_REGISTRACE_CISLOOM_CUST": 'Číslo odberného miesta/EIC/POD',
            "SU_REGISTRACE_CISLOOM_PH": 'Číslo OM/EIC/POD',
            "SU_REGISTRACE_KODMISTA_ERROR": 'Pre identifikáciu zákazníka je potrebné vyplniť kód miesta odberu (číslo odberného miesta, POD, EIC).',
            "SU_REGISTRACE_KODMISTA_ERROR_PND": 'Pro identifikaci zákazníka je zapotřebí vyplnit místo odběru (číslo odběrného místa nebo EAN).',
            "SU_REGISTRACE_KODMISTA_INFO": 'Tento údaj nájdete na poslednom daňovom doklade (faktúre) za energie od ČEZ.',
            "SU_REGISTRACE_KODMISTA_INFO_CUST": 'Tento údaj nájdete na zmluve alebo poslednom daňovom doklade (faktúre) od ČEZ alebo kontaktujte na Zákazníckej linke 0850 888 444, ktorá je Vám k dispozícii v pracovných dňoch od 8:00 do 18:00.',
            "SU_REGISTRACE_TELEFONSMS": 'Telefónne číslo',
            "SU_REGISTRACE_TELEFONSMS_ERROR": 'Nesprávny formát telefónneho čísla',
            "SU_REGISTRACE_TELEFONSMS_INFO": 'Zadajte telefónne číslo, ktoré je evidované pri Vašej zmluve.',
            "SU_REGISTRACE_LOGIN": 'Prihlasovacie meno',
            "SU_REGISTRACE_LOGIN_ERROR": 'Nesprávny formát prihlasovacieho mena.',
            "SU_REGISTRACE_LOGIN_ERROR_MAX": 'Užívateľské meno je príliš dlhé.',
            "SU_REGISTRACE_LOGIN_ERROR_MIN": 'Užívateľské meno je príliš krátke.',
            "SU_REGISTRACE_LOGIN_INFO": 'Prihlasovacie meno nesmie obsahovať diakritiku ani špeciálne znaky (teda len znaky A-Z, 0-9). Ďalej môže obsahovať znaky „." a „_". Dĺžka prihlasovacieho mena je minimálne 8 znakov.',
            "SU_REGISTRACE_POKRACOVAT": 'Pokračovať',
            "SU_REGISTRACE_DOKONCIT_LABEL": 'Dokončiť registráciu',
            "SU_REGISTRACE_DOKONCIT_OVERENI": 'Overenie osobných údajov',
            "SU_REGISTRACE_DATUMNAROZENI_ICO": 'Dátum narodenia alebo IČO',
            "SU_REGISTRACE_DATUMNAROZENI_ICO_ERROR": 'Údaj je v nesprávnom formáte.',
            "SU_REGISTRACE_DATUMNAROZENI_ICO_INFO": 'IČO alebo dátum narodenia obchodného partnera vo formáte  DD.MM.RRRR (napr. 01.01.1970)',
            "SU_REGISTRACE_DATUMNAROZENI": 'Dátum narodenia',
            "SU_REGISTRACE_DATUMNAROZENI_ERROR": 'Dátum narodenia je v nesprávnom formáte.',
            "SU_REGISTRACE_DATUMNAROZENI_INFO": 'Dátum narodenia obchodného partnera vo formáte  DD.MM.RRRR (napr. 01.01.1970)',
            "SU_REGISTRACE_ICO": 'IČ',
            "SU_REGISTRACE_ICO_ERROR": 'IČ musí byť vyplnené',
            "SU_REGISTRACE_ICO_INFO": 'Z bezpečnostných dôvodov prosíme vyplniť IČO firmy',
            "SU_REGISTRACE_TELEFONSMS_OVERENI": 'Telefónne číslo pre overenie',
            "SU_REGISTRACE_TELEFONSMS_ODESLAT": 'Odoslať SMS',
            "SU_REGISTRACE_TELEFONSMS_INFO2": 'Zadajte telefónne číslo, ktoré je uvedené ako kontaktný údaj vo vašej zmluve s ČEZ.',
            "SU_REGISTRACE_TELEFONSMS_INFO3": 'Po odoslaní vám do cca 2 minút pošleme overovací kód.',
            "SU_REGISTRACE_KODSMS": 'Overovací kód',
            "SU_REGISTRACE_KODSMS_INFO": 'Zadajte overovací kód z SMS.',
            "SU_REGISTRACE_KODSMS_ERROR":'Vyplňte overovací kód z SMS',
            "SU_REGISTRACE_NASTAVENIUCTU": 'Nastavenie účtu v ESCO Portálu',
            "SU_REGISTRACE_NASTAVENIUCTU_PND": 'Nastavení účtu v Portále nameraných dát',
            "SU_REGISTRACE_JMENO": 'Meno',
            "SU_REGISTRACE_JMENO_ERROR": 'Meno je v nesprávnom tvare.',
            "SU_REGISTRACE_PRIJMENI": 'Priezvisko',
            "SU_REGISTRACE_PRIJMENI_ERROR": 'Priezvisko je v nesprávnom tvare.',
            "SU_REGISTRACE_EMAIL": 'E-mailová adresa',
            "SU_REGISTRACE_EMAIL_ERROR": 'Nesprávny formát e-mailovej adresy',
            "SU_REGISTRACE_HESLO": 'Zvoľte si heslo pre prihlasovanie do ESCO Portálu',
            "SU_REGISTRACE_HESLO_PND": 'Zvoľte si heslo pre prihlasovanie do Portálu nameraných dát',
            "SU_REGISTRACE_HESLO_PH": 'Zadajte heslo',
            "SU_REGISTRACE_HESLO_ERROR": 'Neplatný formát hesla.',
            "SU_REGISTRACE_HESLO_POZADAVKY": 'Heslo musí obsahovať minimálne 10 znakov, z toho aspoň 1 číslicu, 1 veľké a 1 malé písmeno. Napr. v tvare Heslo12345, 123Heslo45.',
            "SU_REGISTRACE_HESLO_OVERENI": 'Napíšte heslo znovu pre overenie',
            "SU_REGISTRACE_HESLO_OVERENI_ERROR": 'Heslá nie sú zhodné',
            "SU_REGISTRACE_SOUHLAS1": 'Súhlasím s ',
            "SU_REGISTRACE_SOUHLAS2": 'podmienkami prevádzkovania',
            "SU_REGISTRACE_SOUHLAS_CUST": 'Súhlasím s podmienkami prevádzkovania.',
            "SU_REGISTRACE_DOKONCIT": 'Dokončiť',
            "SU_REGISTRACE_SHRNUTI_DEKUJEME": 'Ďakujeme Vám za použitie ESCO Portálu.',
            "SU_REGISTRACE_SHRNUTI_REGISTROVANO": 'Vaša registrácia do ESCO Portálu prebehla úspešne.',
            "SU_REGISTRACE_SHRNUTI_REGISTROVANO_PND": 'Vaše registrace proběhla úspěšně.',
            "SU_REGISTRACE_SHRNUTI_LOGIN": 'Prihlásiť sa',
            "SO_SAMOOBSLUHA_MAIN_TITLE": 'Samoobsluha',
            "SO_SAMOOBSLUHA_1_TITLE": 'Změna výše záloh',
            "SO_SAMOOBSLUHA_2_TITLE": 'Změna způsobu plateb',
            "SO_SAMOOBSLUHA_3_TITLE": 'Změna adresy',
            "SO_SAMOOBSLUHA_4_TITLE": 'Obecný požadavek',
            "SO_SAMOOBSLUHA_5_TITLE": 'Platební brána',
            "SO_SAMOOBSLUHA_5_PEREX": 'Úhrada zálohy nebo faktury prostřednictvím platební karty',
            "SO_SAMOOBSLUHA_ZMENAVYSEZALOH_TITLE": 'Změna výše záloh',
            "SO_SAMOOBSLUHA_ZMENAZPUSOBUPLATEB_TITLE": 'Změna způsobu plateb',
            "SO_SAMOOBSLUHA_ZMENAVADRESY_TITLE": 'Změna adresy',
            "SO_SAMOOBSLUHA_OBECNYPOZADAVEK_TITLE": 'Obecný požadavek',
            "SO_SAMOOBSLUHA_PLATEBNIBRANA_TITLE": 'Platební brána',
            "SO_SAMOOBSLUHA_ZMENAVYSEZALOH_HELPTEXT1": 'Pro vyplnění budete potřebovat fakturu od stávajícího dodavatele',
            "SO_SAMOOBSLUHA_STEP1_TITLE": 'Identifikace',
            "SO_SAMOOBSLUHA_STEP2_TITLE": 'Váš požadavek',
            "SO_SAMOOBSLUHA_STEP3_TITLE": 'Potvrzení',
            "SO_SAMOOBSLUHA_CUSTOMER_NUMBER1": 'Číslo zákazníka:',
            "SO_SAMOOBSLUHA_CUSTOMER_NUMBER2": 'ČEZ zákaznické číslo',
            "SO_SAMOOBSLUHA_SERVICE_TEXT": 'Vyberte službu které se požadavek týká:',
            "SO_SAMOOBSLUHA_KOMODITA_TEXT": 'Komodita (elektřina, plyn)',
            "SO_SAMOOBSLUHA_EIC_EAN_TEXT": 'Číslo odběrného místa, EIC nebo EAN:',
            "SO_SAMOOBSLUHA_EIC_EAN_INFO": 'Identifikační údaje najdete na vaší poslední faktuře za energie od ČEZ.',
            "SO_SAMOOBSLUHA_TEL_NR_TEXT": 'Telefonní číslo:',
            "SO_SAMOOBSLUHA_TEL_NR_PREFIX": '+420',
            "SO_SAMOOBSLUHA_TEL_NR_INFO": 'Zadejte telefonní číslo, které je evidované u vaší smlouvy.',
            "SO_SAMOOBSLUHA_MOBIL_CEZ_TEXT": 'Mobil od ČEZ',
            "SO_SAMOOBSLUHA_CONTINUE_TEXT": 'Pokračovat',
            "SO_SAMOOBSLUHA_STEP2_TEXT_POZADAVKU": 'Text požadavku:',
            "SO_SAMOOBSLUHA_EMAIL_TEXT": 'Email',
            "SO_SAMOOBSLUHA_EMAIL_INFO": 'Na tento e-mail vám budeme zasílat elektronické faktury.',
            "SO_SAMOOBSLUHA_FILE_TEXT": 'Soubor',
            "SO_SAMOOBSLUHA_SEND_REQUEST_TEXT": 'Odeslat dotaz',
            "SO_SAMOOBSLUHA_STEP3_SEND_TITLE": 'Přejete si odeslat následující požadavek?',
            "SO_SAMOOBSLUHA_STEP3_TEXT1_TITLE": 'Text požadavku',
            "SO_SAMOOBSLUHA_STEP3_TEXT2_TITLE": 'Kontaktní údaje',
            "SO_SAMOOBSLUHA_STEP3_TEXT3_TITLE": 'Přílohy',
            "SO_SAMOOBSLUHA_STEP3_SEND2_TITLE": 'Ověření přes SMS',
            "SO_SAMOOBSLUHA_STEP3_TEXT4_TITLE": 'Poslat autentizační SMS',
            "SO_SAMOOBSLUHA_STEP3_TEXT5_TITLE": 'Autentizační kód',
            "SO_SAMOOBSLUHA_STEP3_TEXT5_TEXT": 'Zadejte autentizační kód z SMS.',
            "SO_SAMOOBSLUHA_STEP3_TEXT5_2_TEXT": 'Ověřovací kód byl odeslán.',
            "SO_SAMOOBSLUHA_STEP3_TEXT6_TITLE": 'E-mailová adresa',
            "SO_SAMOOBSLUHA_STEP3_TEXT6_TEXT": 'Vyplňte email pro zaslání potvrzení',
            "SO_SAMOOBSLUHA_STEP3_BUTTON_TITLE": 'Odeslat požadavek',
            "SO_SAMOOBSLUHA_REQUIRED": 'Musí být zadáno',
            "SO_SAMOOBSLUHA_TEL_NUMBER_FORMAT_ERR": 'Číslo musí být ve formátu XXXXXXXXX.',
            "SO_SAMOOBSLUHA_EMAIL_FORMAT_ERR": 'Nesprávný formát e-mailu.',
            "SO_SAMOOBSLUHA_ZVS_CUSTOMER_TITLE": 'Zákazník:',
            "SO_SAMOOBSLUHA_ZVS_ADDRESS_TITLE": 'Adresa odběrného místa:',
            "SO_SAMOOBSLUHA_ZVS_SVZ_TITLE": 'Stávající výše záloh',
            "SO_SAMOOBSLUHA_ZVS_KC_MONTHS_TITLE": 'Kč měsíčně',
            "SO_SAMOOBSLUHA_ZVS_NVZ_TITLE": 'Nová výše záloh',
            "SO_SAMOOBSLUHA_ZVS_MVZ_TEXT": 'Minimální výše záloh je 490 Kč. Nová výše záloh bude zaokrouhlena v souladu s pravidly zaokrouhlování.',
            "SO_SAMOOBSLUHA_ZVS_MVZ_TEXT_1": 'Minimální výše záloh je ',
            "SO_SAMOOBSLUHA_ZVS_MVZ_TEXT_2": ' Kč. Maximální výše záloh je ',
            "SO_SAMOOBSLUHA_ZVS_MVZ_TEXT_3": ' Kč. Nová výše záloh bude zaokrouhlena v souladu s pravidly zaokrouhlování.',
            "SO_SAMOOBSLUHA_ZVS_NVZ_BUTTON": 'Nastavit výši záloh',
            "SO_SAMOOBSLUHA_ZZP_FAKTURY_TITLE": 'Faktury',
            "SO_SAMOOBSLUHA_ZZP_ZU_TITLE": 'Způsob úhrady',
            "SO_SAMOOBSLUHA_ZZP_BS_TITLE": 'Bankovní spojení',
            "SO_SAMOOBSLUHA_ZZP_ZALOHY_TITLE": 'Zálohy',
            "SO_SAMOOBSLUHA_ZZP_SIPO_TITLE": 'Nové spojovací číslo SIPO',
            "SO_SAMOOBSLUHA_ZZP_PREPLATKY_TITLE": 'Přeplatky',
            "SO_SAMOOBSLUHA_ZZP_ZV_TITLE": 'Způsob vyplacení',
            "SO_SAMOOBSLUHA_ZZP_BUTTON": 'Změnit způsob platby',
            "SO_SAMOOBSLUHA_ZA_NATB_TITLE": 'Nová adresa trvalého bydliště',
            "SO_SAMOOBSLUHA_ZA_ULICE_TITLE": 'Ulice',
            "SO_SAMOOBSLUHA_ZA_CP_TITLE": 'Č.p.',
            "SO_SAMOOBSLUHA_ZA_COR_TITLE": 'Č. or.',
            "SO_SAMOOBSLUHA_ZA_PSC_TITLE": 'PSČ',
            "SO_SAMOOBSLUHA_ZA_OBEC_TITLE": 'Obec',
            "SO_SAMOOBSLUHA_ZA_ADR_IS_SAME_TITLE": 'Doručovací adresa je stejná jako adresa trvalého bydliště.',
            "SO_SAMOOBSLUHA_ZA_BUTTON": 'Potvrdit adresu',
            "SO_SAMOOBSLUHA_PB_STEP1_TITLE": 'Částka k úhradě',
            "SO_SAMOOBSLUHA_PB_STEP2_TITLE": 'Dokončení',
            "SO_SAMOOBSLUHA_PB_NAME": 'Jméno',
            "SO_SAMOOBSLUHA_PB_SURNAME": 'Příjmení',
            "SO_SAMOOBSLUHA_PB_EMAIL": 'Email',
            "SO_SAMOOBSLUHA_PB_EMAIL_INFO": 'Na tento e-mail vám budeme zasílat elektronické faktury.',
            "SO_SAMOOBSLUHA_PB_SUM_TO_PAY": 'Částka k zaplacení:',
            "SO_SAMOOBSLUHA_PB_VS": 'Variabilní symbol:',
            "SO_SAMOOBSLUHA_PB_ZAPLATIT_KARTOU": 'Zaplatit kartou',
            "OM_LABEL": 'Odberné miesta',
            "OM_GENERAL_INFO_1": 'Máte',
            "OM_GENERAL_INFO_2V1": 'odberné miesto',
            "OM_GENERAL_INFO_2V2": 'odberné miesta',
            "OM_GENERAL_INFO_2V3": 'odberných miest',
            "OM_GENERAL_INFO_3": 'na',
            "OM_GENERAL_INFO_4V1": 'adrese',
            "OM_GENERAL_INFO_4V2": 'adresách',
            "OM_SEARCH": 'Hľadať',
            "OM_SEARCH_INFO": 'Napíšte adresu, EIC/POD alebo číslo odberného miesta.',
            "OM_MENA": 'EUR',
            "OM_OM": 'Odberné miesto',
            "OM_POJM": 'Pomenovať',
            "OM_PREJM": 'Premenovať',
            "OM_POZN": 'Poznámka OM',
            "OM_SAVE": 'Uložiť',
            "OM_POZN_ERROR": 'Poznámka odberného miesta obsahuje nepovolené znaky.',
            "OM_STORNO": 'Zrušiť',
            "OM_NEBO": 'alebo',
            "OM_INFORMACE": 'Informácie',
            "OM_HDO": 'Hromadné diaľkové ovládanie',
            "OM_SPOTREBICE": 'Nainštalované spotrebiče',
            "OM_PV": 'Plánované vypínanie',
            "OM_HO": 'História odpočtu',
            "OM_ND": 'Namerané hodnoty',
            "OM_VS": 'Vývoj spotreby',
            "OM_DODAVATEL": 'Dodávateľ',
            "OM_DRUHVYROBNY": 'Druh výrobne',
            "OM_OBCHSAZBA": 'Obchodná sadzba',
            "OM_DISTRIBUTOR": 'Distribútor',
            "OM_DISTSAZBA": 'Distribučná sadzba',
            "OM_PRODRADA": 'Produkt',
            "OM_VYSEZALOH": 'Výška záloh',
            "OM_CETNOST": 'Interval záloh',
            "OM_ROCNISPOTR": 'Predpoklad ročnej spotreby',
            "OM_TYPMERENI": 'Typ merania',
            "OM_OSVOBOZENI": 'Oslobodenie od dane',
            "OM_SKUPINAOM": 'Skupina OM',
            "OM_PARAGRAF": 'paragraf',
            "OM_ANO": 'ÁNO',
            "OM_TECHUDAJE": 'Technické údaje',
            "OM_CELM": 'Číslo elektromera',
            "OM_CISLOHDO": 'Číslo HDO',
            "OM_ZPUSOBMERENI": 'Spôsob merania',
            "OM_LEGZPUSOBMERENI": 'Legislatívny spôsob merania',
            "OM_MESREZKAPACITA": 'Mesačná rez. kapacita',
            "OM_ROCREZKAPACITA": 'Ročná rez. kapacita',
            "OM_POCETFAZI": 'Počet fáz',
            "OM_HLJISTIC": 'Hlavný istič',
            "OM_REZPRIKON": 'Rezervovaný príkon',
            "OM_NAPHLADINA": 'Napäťová hladina',
            "OM_SPOTMINOBD": 'Spotreba min. období',
            "OM_TYDENODECTU": 'Týždeň odpočtu',
            "OM_MESICODECTU": 'Mesiac odpočtu',
            "OM_UCKONST": 'Účtovacia konštanta',
            "OM_REGSTUPEN": 'Regulačný stupeň',
            "OM_TARIF": 'Tarifa',
            "OM_PLYNOMER": 'Plynomer',
            "OM_CISLOPLYN": 'Číslo plynomeru',
            "OM_CETNOSTODECTU": 'Interval odpočtu',
            "OM_MESODECTU": 'Mesiac odpočtu',
            "OM_VYUZITI": 'Využitie',
            "OM_CASOVOST": 'Časovosť',
            "OM_TYPSAZBY": 'Typ sadzby',
            "OM_CISLOMERIDLA": 'Číslo meradla',
            "OM_ROCSJEDMN": 'Ročné dohodnuté množstvo',
            "OM_SJEDROCPRIK": 'Dohodnutý ročný príkon',
            "OM_POCETBYTJEDN": 'Počet bytových jednotiek',
            "OM_ROZDOD": 'Rozdelenie dodávky',
            "OM_BYTNEBYT": 'byt/nebyt [% byt]',
            "OM_PODLPLOCHA": 'Podlahová plocha',
            "OM_BYTNEBYT2": 'byt/nebyt [m²]',
            "OM_IDVYROBNY": 'ID výrobne',
            "OM_IDZDROJE": 'ID zdroje',
            "OM_DODDOSITE": 'Dodávka do siete',
            "OM_DRUHPODP": 'Druh podpory',
            "OM_ODECTJEDN": 'Odpočtová jednotka',
            "OM_FAKUDAJE": 'Fakturačné údaje',
            "OM_ZPUHRADY": 'Spôsob úhrady',
            "OM_ZPUVRAC": 'Spôsob vrátenia',
            "OM_CU": 'Číslo účtu',
            "OM_IBAN": 'IBAN',
            "OM_SIPO": 'Spojovacie číslo SIPO',
            "OM_KONTUDAJ": 'Kontaktné údaje',
            "OM_ADRESA": 'Adresa trvalého bydliska',
            "OM_ZASADRESA": 'Korešpondenčná adresa',
            "OM_ZMENITUDAJE": 'Zmeniť údaje',
            "OM_ZMENIT": 'Zmeniť',
            "OM_SLUZBY": 'Ponúkané služby',
            "OM_ELFA": 'Elektronická fakturácia',
            "OM_ELFA_KONTAKT": 'Kontakt pro notifikáciu',
            "OM_AKTIVNI": 'Aktívne',
            "OM_NEAKTIVNI": 'Neaktívne',
            "OM_AKTIVOVAT": 'Aktivovať',
            "OM_DATSOUBOR": 'Dátový súbor',
            "OM_POJIST": 'ČEZ Bez starostí',
            "OM_PND": 'Portál nameraných dát',
            "OM_ASISTENT": 'ČEZ ASISTENT',
            "OM_MESFAK": 'Mesačná faktúra',
            "OM_FAK24": 'Faktúra 24',
            "OM_EFAK": 'e-faktúra',
            "OM_OZNODST": 'Oznamovanie odstávok',
            "OM_SMLOBCH": 'Zmluva / Obchodný zástupca',
            "OM_VYSTAVIT": 'Vystaviť',
            "OM_OZ": 'Obchodný zástupca',
            "OM_JMENO": 'Meno',
            "OM_TEL": 'Telefón',
            "OM_MOB": 'Mobil',
            "OM_EMAIL": 'E-mail',
            "OM_VS_DATEPICK": 'Zobraziť dáta za obdobie',
            "OM_OD": 'Od',
            "OM_DO": 'Do',
            "OM_DATUMODDO": 'Dátum od - do',
            "OM_SPVT": 'Spotreba VT [kWh]',
            "OM_SPNT": 'Spotreba NT [kWh]',
            "OM_SP": 'Spotreba [kWh]',
            "OM_AVGSPVT": 'Priemerná spotreba VT [kWh/deň]',
            "OM_AVGSPNT": 'Priemerná spotreba NT [kWh/deň]',
            "OM_AVGSP": 'Priemerná spotreba [kWh/deň]',
            "OM_SAZBAOBCH": 'Sadzba obchod',
            "OM_SAZBADIST": 'Sadzba distribúcia',
            "OM_CENA": 'Cena',
            "OM_SPOTREBIC": 'Spotrebič',
            "OM_EVIDKW": 'Evidované kW',
            "OM_NOVEKW": 'Nové kW',
            "OM_KODHDO": 'Kód HDO',
            "OM_CHARODB": 'Charakteristika odberu',
            "OM_INSTPRIK": 'Nainštalovaný príkon',
            "OM_RIZPRIK": 'Riadený príkon',
            "OM_SIGNAL": 'Signál',
            "OM_ZOBRKDATU": 'Zobraziť k dátumu',
            "OM_DEN": 'Deň',
            "OM_DATUM": 'Dátum',
            "OM_CASY": 'Časy',
            "OM_VT": 'VT (kWh)',
            "OM_NT": 'NT (kWh)',
            "OM_POPIS": 'Opis',
            "OM_STAVM3": 'Stav (m3)',
            "OM_STAV": 'Stav',
            "OM_ZADNEVYPINANI": 'K odbernému miestu neevidujeme k dnešnému dňu žiadne plánované vypnutie elektriny.',
            "OM_TERMIN": 'Termín',
            "OM_DUVOD": 'Dôvod',
            "OM_KOMODITA_ELE": 'Elektrina',
            "OM_KOMODITA_PLYN": 'Plyn',
            "OM_KOMODITA_TEPLO": 'Teplo',
            "OM_KOMODITA_MOB": 'Mobil od ČEZ',
            "OM_KOMODITA_JINE": 'Iné',
            "OM_KOMODITA_VYROBNA": 'Elektrina',
            "OM_UNK": 'Nerozpoznané',
            "OM_ZAL_NE": 'Nie sú zálohy',
            "OM_ZAL_MES": 'Mesačné zálohy',
            "OM_ZAL_DVMES": 'Dvojmesačné zálohy',
            "OM_ZAL_CTVRTLET": 'Štvrťročné zálohy',
            "OM_ZAL_CTYRMES": 'Štvormesačné zálohy',
            "OM_ZAL_PULR": 'Polročné zálohy',
            "OM_ZAL_ROCNI": 'Ročné zálohy',
            "OM_ZPMER_PRIME": 'Priame meranie',
            "OM_ZPMER_POLOPRIME": 'Polopriame meranie',
            "OM_ZPMER_NEPRIME": 'Nepriame meranie',
            "OM_ZPMER_NEPRPRIMECAST": 'Nepr./čiast. nepr. meranie',
            "OM_MES1": 'Január',
            "OM_MES2": 'Február',
            "OM_MES3": 'Marec',
            "OM_MES4": 'Apríl',
            "OM_MES5": 'Máj',
            "OM_MES6": 'Jún',
            "OM_MES7": 'Júl',
            "OM_MES8": 'August',
            "OM_MES9": 'September',
            "OM_MES10": 'Október',
            "OM_MES11": 'November',
            "OM_MES12": 'December',
            "OM_NEURCENO": 'Neurčené',
            "OM_OMELE1": 'odberné miesto elektriny',
            "OM_OMELE2": 'odberné miesta elektriny',
            "OM_OMELE3": 'odberných miest elektriny',
            "OM_OMPLYN1": 'odberné miesto plynu',
            "OM_OMPLYN2": 'odberné miesta plynu',
            "OM_OMPLYN3": 'odberných miest plynu',
            "OM_OMTEP1": 'odberné miesto tepla',
            "OM_OMTEP2": 'odberné miesta tepla',
            "OM_OMTEP3": 'odberných miest tepla',
            "OM_OMVYR1": 'výrobňa elektriny',
            "OM_OMVYR2": 'výrobne elektriny',
            "OM_OMVYR3": 'výrobní elektriny',
            "OM_OMPOZE": 'POZE',
            "OM_ZADNAOM": 'Pre dané zákaznícke číslo nie sú evidované žiadne odberné miesta.',
            "OM_ZADNAOM_PF": 'Pro dané zákaznické číslo nejsou evidována žádná odběrná místa, kterým lze provést predikci faktury.',
            "OM_SMLVYST": 'Stav zmluvy: Vystavuje sa',
            "OM_NASTAVIT": 'Nastaviť',
            "OM_ELEOZNNN": 'Zasielanie správ o plánovaných odstávkách',
            "OM_SML_PRODEJ": 'Zmluva s ',
            "OM_SML_DIST": 'Zmluva s ',
            "OM_SML_PRODEJ_SHORT": '(ČEZ Prodej, a.s.)',
            "OM_SML_DIST_SHORT": '(ČEZ Distribuce, a.s.)',
            "OM_ADV_SEARCH": 'Rozšírené hľadanie',
            "OM_NOTITLE": 'Poznámka OM nebola vyplnená.',
            "OM_ZALOHY": 'Zálohy',
            "OM_PREPLATKY": 'Preplatky',
            "OM_ZAEVIDOVAN": 'Požiadavka bola zaevidovaná',
            "OM_ODST_INFO": 'Zobrazené informácie o plánovanej odstávke elektriny majú iba informatívny charakter.',
            "FA_LABEL": 'Faktúry a zálohy',
            "FA_VSECHNAOM": 'Pre všetky odberné miesta.',
            "FA_VSECHNAOP": 'Pre všetkých obchodných partnerov.',
            "FA_ZVOLOM": 'Len pre vybrané odberné miesta.',
            "FA_VYBRATOM": 'Vybrať odberné miesta',
            "FA_AKTUALIZOVANO": 'Zobrazené dáta boli aktualizované',
            "FA_UPDATE": 'aktualizovať',
            "FA_FILTR": 'Filter',
            "FA_VLASTNI": 'Vlastné',
            "FA_ADVSEARCH": 'Podrobné hľadanie',
            "FA_STORNO": 'Zrušiť',
            "FA_NORESULTS": 'Neboli nájdené žiadne výsledky.',
            "FA_SEARCH": 'Hľadať',
            "FA_SEARCH_INFO": 'Napíšte sumu, alebo variabilný symbol.',
            "FA_DOKLAD": 'Doklad',
            "FA_DOPLATIT": 'Suma na doplatenie',
            "FA_STAV": 'Stav',
            "FA_ZDANPLNENI": 'Zdaniteľné plnenie',
            "FA_VARSYMBOL": 'Variabilný symbol',
            "FA_VARSYMBOL_DESC": 'Variabilný symbol zostupne',
            "FA_VARSYMBOL_PH": 'Var. symbol',
            "FA_SPLATNOST": 'Splatnosť',
            "FA_PRIDATDOKOSIKU": 'Pridať k úhrade',
            "FA_PLATBANACESTE": 'Platba na ceste',
            "FA_VKOSIKU": 'Pridané',
            "FA_SORTBY": '-- Zoradiť podľa --',
            "FA_DATVYST": 'Dátumu vystavenia',
            "FA_DATVYST_DESC": 'Dátumu vystavenia zostupne',
            "FA_DATSPLAT": 'Dátumu splatnosti',
            "FA_DATSPLAT_DESC": 'Dátumu splatnosti zostupne',
            "FA_MAXTOP": 'Sumy',
            "FA_MINTOP": 'Sumy zostupne',
            "FA_SELECT": 'Vybrať',
            "FA_SELECT_LABEL": '-- Vybrať --',
            "FA_ALL": 'Všetko',
            "FA_NONE": 'Nič',
            "FA_REVERSE": 'Naopak',
            "FA_POHL": 'Pohľadávky',
            "FA_NEUHRAZENE": 'Neuhradené',
            "FA_AKCE": 'Akcia',
            "FA_DLPDF": 'Stiahnuť ako PDF',
            "FA_DLCSV": 'Stiahnuť ako CSV',
            "FA_SLREAD": 'Označiť ako prečítané',
            "FA_SLUNREAD": 'Označiť ako neprečítané',
            "FA_SELECTOM": 'Vyberte odberné miesto',
            "FA_SEARCHOM_INFO": 'Napíšte adresu, EIC/POD, alebo číslo odberného miesta.',
            "FA_ADVSEARCH_LABEL": 'Podrobné vyhľadávanie dokladov',
            "FA_KOMODITA_ELE": 'Elektrina',
            "FA_KOMODITA_PLYN": 'Plyn',
            "FA_KOMODITA_TEPLO": 'Teplo',
            "FA_LKOMODITA_MOBIL": 'Mobil od ČEZ',
            "FA_KOMODITA_JINE": 'Iné',
            "FA_KOMODITA_VYROBNA": 'Elektrina',
            "FA_ZALOHY": 'Zálohy',
            "FA_FAKTURY": 'Faktúry',
            "FA_PRIJPLATBY": 'Prijaté platby',
            "FA_UPOMINKY": 'Upomienky',
            "FA_DALSIDOKL": 'Ďalšie doklady',
            "FA_SMLPOKUTY": 'Zmluvné pokuty',
            "FA_POPLATKY": 'Poplatky',
            "FA_KAUCE": 'Kaucie',
            "FA_NEZZAL": 'Nezaúčtované zálohy',
            "FA_SELFBIL": 'Self-billing',
            "FA_UROKY": 'Úroky',
            "FA_ZNOVUPRIP": 'Znovupripojenie',
            "FA_ZASTPRIP": 'Zastavenie prerušenia',
            "FA_STORNA": 'Storná',
            "FA_OST": 'Ostatné',
            "FA_SPLATVOBD": 'Splatnosť v období',
            "FA_ZMENIT": 'Zmeniť',
            "FA_OD": 'Od',
            "FA_DO": 'Do',
            "FA_BLIZISESPLAT": 'Blíži sa splatnosť',
            "FA_MINMESIC": 'Minulý mesiac',
            "FA_CELYROK": 'Celý rok',
            "FA_LONSKYROK": 'Minulý rok',
            "FA_BEZOMEZENÍ": 'Bez obmedzenia',
            "FA_VYSTVOBD": 'Vystavené v období',
            "FA_POSLTYDEN": 'Posledný týždeň',
            "FA_CASTKA": 'Suma',
            "FA_INPROZSAH": 'Zadať rozsah',
            "FA_STRCASTKA": 'Presná suma',
            "FA_ZBYVADOPL": 'Zostáva doplatiť',
            "FA_DOPLOD": 'Doplatiť od',
            "FA_CISLOMERIDLA": 'Číslo meradla',
            "FA_CISLOMERIDLA_PH": 'Č. meradla',
            "FA_POUZENEZAPL": 'Len nezaplatené',
            "FA_SHOWRESULTS": 'Zobraziť výsledky',
            "FA_DOKLKZAPL": 'Doklady k zaplateniu',
            "FA_CARTEMPTY": 'Košík je prázdny',
            "FA_TOTAL": 'Celková suma k úhrade',
            "FA_PAYMETHOD": 'Vyberte platobnú metódu',
            "FA_PAY": 'Prejsť na platobnú bránu',
            "FA_VYSTAVENI": 'Vystavenie',
            "FA_CISLODD": 'Číslo daň. dokladu',
            "FA_DETAILPLATEB": 'Detail platieb',
            "FA_MENA": 'Mena',
            "FA_UHRAZENO": 'Uhradené',
            "FA_DALSIINFO": 'Ďalšie informácie',
            "FA_DODINFO": 'Dodatočné informácie',
            "FA_NOTIFIKACE": 'Notifikácia',
            "FA_TYP": 'Typ',
            "FA_DATUM": 'Dátum',
            "FA_PRIJEMCE": 'Príjemca',
            "FA_HISTUPO": 'História upomínania',
            "FA_TYPUPO": 'Typ upomienky',
            "FA_VYSTAVENO": 'Vystavené',
            "FA_VYTVORENO": 'Vytvorené',
            "FA_PLATBA": 'Platba',
            "FA_ZBYVAUHR": 'Zostáva uhradiť',
            "FA_DL": 'Stiahnuť',
            "FA_SOUVDOK": 'Súvisiace doklady',
            "FA_DRUHDOK": 'Druh dokladu',
            "FA_DATZAZ": 'Dátum záznamu',
            "FA_CISLOKONT": 'Číslo kontaktu',
            "FA_FAKTUROVANO": 'Fakturované',
            "FA_KESTAZENI": 'Na stiahnutie',
            "FA_SOUHFAK": 'Súhrnná faktúra',
            "FA_POKUTAZAHR": 'Pokuta zahrnutá v upomienke',
            "FA_PLATBADOK": 'Platba dokladu',
            "FA_NADDOK": 'Nadradený doklad',
            "FA_VICE": 'Zobraziť viac',
            "FA_BANKA": 'Hradiť v prospech účtu',
            "FA_CISLOU": 'Číslo účtu',
            "FA_IBAN": 'IBAN',
            "FA_UCET": 'účet',
            "FA_OM": 'Odberné miesta',
            "FA_CISLOOM": 'Číslo OM',
            "FA_ADRESA": 'Adresa',
            "FA_POZN": 'Poznámka',
            "FA_UPDATE_WARN": 'Aktualizáciou stránky dôjde k výmazu položiek v košíku, naozaj chcete pokračovať?',
            "FA_STATUS_UHRAZENO": 'Uhradené',
            "FA_STATUS_PREDSPL": 'Pred splatnosťou',
            "FA_STATUS_NEUHRAZENO": 'Neuhradené',
            "FA_STATUS_PRIJPLT": 'Prijatá platba',
            "FA_STATUS_KVYPL": 'K výplate',
            "FA_STATUS_VYPLACENO": 'Vyplatené',
            "FA_STATUS_VLADNI_PODPORA": 'Vládná podpora',
            "FA_STATUS_NEPLAT": 'Neplaťte',
            "FA_STATUS_PREVEDENO": 'Prevedené',
            "FA_STATUS_VYFAK": 'Vyfakturované',
            "FA_STATUS_NENIPOZ": 'Nie je požadované',
            "FA_STATUS_NEVYPL": 'Nevyplatené',
            "FA_STATUS_VSOUHF": 'Zahrnuté v súhrnnej faktúre',
            "FA_STATUS_VSOUHZ": 'Zahrnuté v súhrnnej zálohe',
            "FA_STATUS_PAYU": 'Uhrazeno',
            "FA_STATUS_INKASOVANO": 'Inkasuje',
            "FA_TYPDOKLADU_ALL": 'Celkový prehľad',
            "FA_TYPDOKLADU_BBP": 'Záloha',
            "FA_TYPDOKLADU_INV": 'Faktúra',
            "FA_TYPDOKLADU_PLB": 'Platba',
            "FA_TYPDOKLADU_UPO": 'Upomienka',
            "FA_TYPDOKLADU_POK": 'Zmluvná pokuta',
            "FA_TYPDOKLADU_POZ": 'Poplatok',
            "FA_TYPDOKLADU_KAU": 'Kaucia',
            "FA_TYPDOKLADU_BBO": 'Nezaúčtovaná záloha',
            "FA_TYPDOKLADU_SLF": 'Self-billing',
            "FA_TYPDOKLADU_URO": 'Úrok',
            "FA_TYPDOKLADU_PRI": 'Znovupripojenie',
            "FA_TYPDOKLADU_PRE": 'Zastavenie prerušenia',
            "FA_TYPDOKLADU_STN": 'Storno',
            "FA_TYPDOKLADU_OST": 'Ostatné',
            "FA_TYPDOKLADU_UNK": 'Neznáma položka',
            "FA_DATE_DEN1": ' deň',
            "FA_DATE_DEN2": ' dni',
            "FA_DATE_DEN3": ' dní',
            "FA_DATE_SPLZA": 'Splatnosť za ',
            "FA_DATE_POSPL": ' po splatnosti.',
            "FA_DATE_SPLDNES": 'Splatnosť dnes',
            "FA_DATE_CHYBA": 'Chyba: ',
            "FA_TYPNOTIF_SMS": 'SMS',
            "FA_TYPNOTIF_EMAIL": 'E-mail',
            "FA_TYPNOTIF_DOPIS": 'List',
            "FA_TYPNOTIF_UNK": 'Neznámé',
            "FA_PDF_PROGRESS": 'PDF doklad faktúry pre Vás práve pripravujeme, k dispozícii bude najneskôr do 2 pracovných dní od dátumu vystavenia faktúry.',
            "DA_LABEL": 'Prehľad účtu',
            "DA_FA": 'Faktúry',
            "DA_SEARCH": 'Hľadať',
            "DA_SEARCH_INFO": 'Napíšte sumu, alebo variabilný symbol.',
            "DA_ADVSEARCH": 'Podrobné vyhľadávanie',
            "DA_OM": 'Odberné miesta',
            "DA_OMSEARCH_INFO": 'Napíšte adresu, EIC/POD, alebo číslo odberného miesta.',
            "DA_MOB": 'Mobil od ČEZ',
            "DA_CISLOOM": 'Číslo odberného miesta',
            "DA_DATUM_OD": 'Dátum od',
            "DA_DATUM_DO": 'Dátum do',
            "DA_ADRESA": 'Adresa',
            "DA_DUVOD": 'Dôvod',
            "DA_ODSTAVKY": 'Odstávky',
            "DA_PREJDETE": 'Prejdite k ČEZ',
            "DA_PRODOMACNOST": 'pre domácnosť',
            "DA_PROFIRMY": 'pre firmy',
            "DA_UDAJESPRAVNE": 'Sú tieto údaje správne?',
            "DA_ZKONTRUD": 'Skontrolujte si prosím svoje kontaktné údaje. Predídete tým prípadným nedorozumeniam.',
            "DA_ZAKCIS": 'Zákaznicke číslo',
            "DA_ADRESATB": 'Adresa trvalého bydliska',
            "DA_ADRESASF": 'Adresa sídla firmy',
            "DA_ZMENITUD": 'Zmeniť údaje',
            "DA_TELEFON": 'Telefón',
            "DA_MOBIL": 'Mobil',
            "DA_EMAIL": 'E-mailová adresa',
            "DA_DATA_BOX": 'Dátová schránka',
            "DA_OK": 'OK, údaje sú v poriadku',
            "DA_ZADNE_ODSTAVKY": 'Nie sú evidované žiadne odstávky.',
            "DA_ADVSEARCHOM": 'Podrobné hľadanie odberných miest',
            "DA_ULICE": 'Ulice',
            "DA_CP": 'Č.popisné',
            "DA_MESTO": 'Mesto',
            "DA_PSC": 'PSČ',
            "DA_KOMODITA": 'Komodita',
            "DA_EANEIC": 'EAN / EIC',
            "DA_ZOBRVYSL": 'Zobraziť výsledky',
            "DA_NEDOSTUPNOST": 'Vážení zákazníci, dovoľujeme si vás upozorniť na plánovanú nedostupnosť ESCO Portálu.',
            "PF_NADPIS_GRAF": 'Předpokládaný průběh spotřeby elektřiny dle TDD',
            "PF_NADPIS_GRAF_PLYN": 'Předpokládaný průběh spotřeby plynu dle TDD',
            "PF_STAV": 'Předpokládaný stav elektroměru',
            "PF_STAV_PLYN": 'Předpokládaný stav plynoměru',
            "PF_CETNOST_1": 'Vaše aktuální výše měsíčních záloh:',
            "PF_CETNOST_3": 'Vaše aktuální výše čtvrtletních záloh:',
            "PF_CETNOST_N": 'Vaše aktuální výše záloh:',
            "MRK_MAIN_TITLE": 'Rezervované kapacity OM z hladiny VN a VVN',
            "MRK_PRO_ODB_MISTO": 'Pro odběrné místo',
            "MRK_CHANGE": 'Změnit',
            "MRK_INFO_TEXT_1": 'Snížení roční rezervované kapacity je možné provádět po uplynutí 12 měsíců od poslední změny a vždy čeká na schválení příslušným distributorem.',
            "MRK_YEAR": 'Rok',
            "MRK_REZ_PRIKON": 'Rezervovaný příkon',
            "MRK_KWH": 'kWh',
            "MRK_KW": 'kW',
            "MRK_ROCNI_REZ_KAP": 'Roční rez. kap.',
            "MRK_EVIDOVANA_HOD": 'Měsíční evidovaná rez. kap.',
            "MRK_SJEDNANA_HOD": 'Měsíční požadovaná rez. kap.',
            "MRK_MES1": 'Leden',
            "MRK_MES2": 'Únor',
            "MRK_MES3": 'Březen',
            "MRK_MES4": 'Duben',
            "MRK_MES5": 'Květen',
            "MRK_MES6": 'Červen',
            "MRK_MES7": 'Červenec',
            "MRK_MES8": 'Srpen',
            "MRK_MES9": 'Září',
            "MRK_MES10": 'Říjen',
            "MRK_MES11": 'Listopad',
            "MRK_MES12": 'Prosinec',
            "MRK_SAVE_CHANGES": 'Uložit změny',
            "MRK_OR": 'nebo',
            "MRK_BACK": 'zpět',
            "SD_SOHEDM_TITLE": 'Sjednání odběrových hodnot EDM',
            "SD_PRO_ODB_MISTO": 'Pro odběrné místo:',
            "SD_CHANGE": 'Změnit',
            "SD_CHOOSE_PROFIL": 'Vyberte profil a výpis',
            "SD_PROFIL": 'Profil',
            "SD_PROFIL_1": 'Denní',
            "SD_PROFIL_2": 'Týdenní',
            "SD_PROFIL_3": 'Skutečné hodnoty',
            "SD_PROFIL_4": 'Všechny profily',
            "SD_FROM_DATE": 'Od data',
            "SD_FROM_1": 'Automaticky',
            "SD_FROM_2": 'Zvolit datum',
            "SD_BUTTON_SHOW_PROFIL": 'Zobrazit vybraný profil',
            "SD_BUTTON_EXPORT_XLS": 'Export hodnot do MS Excel',
            "SD_OR": 'nebo',
            "SD_BACK": 'Zpět',
            "SD_MONTH": 'měsíc',
            "SD_WEEK": 'týden',
            "SD_DAY": 'den',
            "SD_SET_DISPLAY": 'Nastavit zobrazení',
            "SD_SAVE_DATA": 'Uložit zadaná data',
            "SD_JEDNOTKY": 'Jednotky sjednávání jsou',
            "SD_SET": 'Nastavit',
            "SD_SJEDNANI_SETTING_TITLE": 'Sjednání odběrových hodnot EDM - nastavení',
            "SD_TABLE": 'Tabulka',
            "SD_DAY_NRS": 'Počet dní',
            "SD_GENERAL": 'Obecné',
            "SD_REFRESH": 'Refresh',
            "SD_CONTACT_PERSON": 'Kontaktní osoba',
            "SD_JEDNOTKY2": 'Jednotky pro elektřinu',
            "SF_TITLE": 'Simulace faktury',
            "SF_PRO_ODB_MISTO": 'Pro odběrné místo:',
            "SF_CHANGE": 'Změnit',
            "SF_NAPOVEDA": 'Nápověda',
            "SF_NAPOVEDA_TEXT": 'Faktura bude simulována ke zvolenému dni. Ten musí být zadán v rozmezí od data poslední fakturace do dnešního dne.',
            "SD_SPOTREBA_TITLE": 'Zadejte spotřebu přístroje',
            "SD_DATUM_SAMOODECTU": 'Datum samoodečtu',
            "SD_POSLEDNI_FAK_STAV_VT": 'Poslední fakturovaný stav VT',
            "SD_SAMOODECET_VYS_TARIFU": 'Samoodečet vysokého tarifu',
            "SD_KWH": 'kWh',
            "SD_POSLEDNI_FAK_STAV_NT": 'Poslední fakturovaný stav NT',
            "SD_SAMOODECET_NIZ_TARIFU": 'Samoodečet nízkého tarifu',
            "SD_SAMOODECET": 'Samoodečet',
            "SD_POSLEDNI_FAK_STAV": 'Poslední fakturovaný stav',
            "SD_VYGENEROVAT_FAKTURU": 'Vygenerovat fakturu',
            "SF_ALERT_WARNING": 'Výpočet je pouze orientační, simulace vyúčtovací faktury nenahrazuje řádnou vyúčtovací fakturu.',
            "SF_SIMUL_TO_DATE": 'Simulovaná faktura ke dni',
            "SF_MACHINE_NR": 'Číslo přístroje',
            "SF_SPOTREBA_ZA_OBD": 'Spotřeba za období',
            "SF_SPOTREBA_ZA_OBD_VT": 'Spotřeba za období VT',
            "SF_SPOTREBA_ZA_OBD_VNT": 'Spotřeba za období VT + NT',
            "SF_PREDPOKLAD_CENA": 'Předpokládaná cena',
            "SF_PRIJATE_PLATBY": 'Přijaté platby',
            "SF_ROZDIL": 'Rozdíl',
            "SF_PREPLATEK": 'Přeplatek',
            "SF_PRINT_INVOICE": 'Vytisknout fakturu',
            "SF_INCLUDING_VAT": 'Veškeré položky jsou uvedeny včetně DPH.',
            "SF_DOPLATEK": 'Doplatek'
        });
        $translateProvider.useSanitizeValueStrategy('escape');
    }]);